(window.theme = window.theme || {}),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (t, e) {
    for (var s = 0, r = t.options.length; s < r; s++) {
      var i = t.options[s];
      if (e == i.value || e == i.innerHTML) return (t.selectedIndex = s);
    }
  }),
  (Shopify.addListener = function (t, e, s) {
    t.addEventListener
      ? t.addEventListener(e, s, !1)
      : t.attachEvent("on" + e, s);
  }),
  (Shopify.postLink = function (t, e) {
    var s,
      r = (e = e || {}).method || "post",
      i = e.parameters || {},
      a = document.createElement("form");
    for (s in (a.setAttribute("method", r), a.setAttribute("action", t), i)) {
      var n = document.createElement("input");
      n.setAttribute("type", "hidden"),
        n.setAttribute("name", s),
        n.setAttribute("value", i[s]),
        a.appendChild(n);
    }
    document.body.appendChild(a), a.submit(), document.body.removeChild(a);
  }),
  (Shopify.CountryProvinceSelector = function (t, e, s) {
    (this.countryEl = document.getElementById(t)),
      (this.provinceEl = document.getElementById(e)),
      (this.provinceContainer = document.getElementById(s.hideElement || e)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var t = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
    },
    initProvince: function () {
      var t = this.provinceEl.getAttribute("data-default");
      t &&
        0 < this.provinceEl.options.length &&
        Shopify.setSelectorByValue(this.provinceEl, t);
    },
    countryHandler: function (t) {
      var e = (r =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces"
        ),
        s = JSON.parse(e);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var r, i = 0; i < s.length; i++)
          ((r = document.createElement("option")).value = s[i][0]),
            (r.innerHTML = s[i][1]),
            this.provinceEl.appendChild(r);
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (t) {
      for (; t.firstChild; ) t.removeChild(t.firstChild);
    },
    setOptions: function (t, e) {
      var s = 0;
      for (e.length; s < e.length; s++) {
        var r = document.createElement("option");
        (r.value = e[s]), (r.innerHTML = e[s]), t.appendChild(r);
      }
    },
  }),
  (theme.config = {
    mediaQueries: {
      landscapeAll: "screen and (orientation: landscape)",
      landscape:
        "screen and (orientation: landscape), screen and (min-width: 48rem)",
      belowTablet: "screen and (max-width: 47.99rem)",
      tablet: "screen and (min-width: 48rem)",
      belowLaptop: "screen and (max-width: 63.99rem)",
      laptop: "screen and (min-width: 64rem)",
      belowDesktop: "screen and (max-width: 64rem)",
      desktop: "screen and (min-width: 64.01rem)",
      belowWidescreen: "screen and (max-width: 79.99rem)",
      widescreen: "screen and (min-width: 80rem)",
      belowExtrawide: "screen and (max-width: 89.99rem)",
      extrawide: "screen and (min-width: 90rem)",
    },
    money: { format: "${{amount}}" },
    upsellLimit: 6,
  }),
  (theme.utils = {
    a11y: {
      getFocusableElements(t) {
        return Array.from(
          t.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        );
      },
      _trapFocusHandlers: {},
      trapFocus(e, t = e) {
        var s = theme.utils.a11y.getFocusableElements(e),
          r = s[0],
          i = s[s.length - 1];
        theme.utils.a11y.removeTrapFocus(),
          (theme.utils.a11y._trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== i && t.target !== r) ||
              document.addEventListener(
                "keydown",
                theme.utils.a11y._trapFocusHandlers.keydown
              );
          }),
          (theme.utils.a11y._trapFocusHandlers.focusout = function () {
            document.removeEventListener(
              "keydown",
              theme.utils.a11y._trapFocusHandlers.keydown
            );
          }),
          (theme.utils.a11y._trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() &&
              (t.target !== i || t.shiftKey || (t.preventDefault(), r.focus()),
              (t.target !== e && t.target !== r) ||
                !t.shiftKey ||
                (t.preventDefault(), i.focus()));
          }),
          document.addEventListener(
            "focusout",
            theme.utils.a11y._trapFocusHandlers.focusout
          ),
          document.addEventListener(
            "focusin",
            theme.utils.a11y._trapFocusHandlers.focusin
          ),
          t.focus();
      },
      removeTrapFocus(t = null) {
        document.removeEventListener(
          "focusin",
          theme.utils.a11y._trapFocusHandlers.focusin
        ),
          document.removeEventListener(
            "focusout",
            theme.utils.a11y._trapFocusHandlers.focusout
          ),
          document.removeEventListener(
            "keydown",
            theme.utils.a11y._trapFocusHandlers.keydown
          ),
          t && t.focus();
      },
    },
    prepareTransition(t) {
      t.addEventListener("transitionend", () => {
        t.classList.remove("is-transitioning");
      });
      let e = 0;
      const s = getComputedStyle(t);
      [
        "transition-duration",
        "-moz-transition-duration",
        "-webkit-transition-duration",
        "-o-transition-duration",
      ].forEach((t) => (e = e || parseFloat(s.getPropertyValue(t)))),
        0 != e && (t.classList.add("is-transitioning"), t.offsetWidth);
    },
    defaultTo: function (t, e) {
      return null == t || t != t ? e : t;
    },
    formatMoney(t, e) {
      "string" == typeof t && (t = t.replace(".", ""));
      var s = "",
        r = /\{\{\s*(\w+)\s*\}\}/,
        e = e || theme.config.money.format;
      function i(t, e, s, r) {
        if (
          ((e = theme.utils.defaultTo(e, 0)),
          (s = theme.utils.defaultTo(s, ",")),
          (r = theme.utils.defaultTo(r, ".")),
          isNaN(t) || null == t)
        )
          return 0;
        t = (t = (t / 100).toFixed(0)).split(".");
        return (
          t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
          (t[1] ? r + t[1] : "")
        );
      }
      switch (e.match(r)[1]) {
        case "amount":
          s = i(t, 2);
          break;
        case "amount_no_decimals":
          s = i(t, 0);
          break;
        case "amount_with_space_separator":
          s = i(t, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = i(t, 0, ",", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          s = i(t, 0, " ");
      }
      return e.replace(r, s);
    },
    serializeForm: (t) => {
      const e = {},
        s = new FormData(t);
      for (const r of s.keys()) {
        const i = /(?:^(properties\[))(.*?)(?:\]$)/;
        i.test(r)
          ? ((e.properties = e.properties || {}),
            (e.properties[i.exec(r)[2]] = s.get(r)))
          : (e[r] = s.get(r));
      }
      return JSON.stringify(e);
    },
    debounce(e, s) {
      let r;
      return (...t) => {
        clearTimeout(r), (r = setTimeout(() => e.apply(this, t), s));
      };
    },
    getSiblings(t, e) {
      let s = [],
        r;
      r = e
        ? t.parentNode.querySelectorAll(":scope > " + e)
        : t.parentNode.children;
      for (var i of r) i !== t && s.push(i);
      return s;
    },
  });
class CartAPI {
  static async get() {
    CartAPI._trigger(CartAPI._events.fetch.before);
    try {
      let t = await fetch("/cart.js");
      var e = await t.json();
      return CartAPI._trigger(CartAPI._events.fetch.complete, { cart: e }), e;
    } catch (t) {
      CartAPI._trigger(CartAPI._events.fetch.error, { error: t }),
        CartAPI._onError(t);
    }
  }
  static async add(e) {
    CartAPI._trigger(CartAPI._events.add.before);
    try {
      let t = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(e),
        ...CartAPI._fetchConfig,
      });
      if (((t = await t.json()), t.status)) throw t;
      return CartAPI._trigger(CartAPI._events.add.complete, { item: t }), t;
    } catch (t) {
      CartAPI._trigger(CartAPI._events.add.error, { error: t }),
        CartAPI._onError(t);
    }
  }
  static async addFromForm(e) {
    if (e && e instanceof HTMLElement) {
      CartAPI._trigger(CartAPI._events.add.before);
      try {
        let t = await fetch("/cart/add.js", {
          method: "POST",
          body: theme.utils.serializeForm(e),
          ...CartAPI._fetchConfig,
        });
        if (((t = await t.json()), t.status)) throw t;
        var elements = document.getElementsByClassName("product-quick-view");
        for (var i = 0; i < elements.length; i++) {
          elements[i].style.display = "none";
        }
        return CartAPI._trigger(CartAPI._events.add.complete, { item: t }), t;
      } catch (t) {
        CartAPI._trigger(CartAPI._events.add.error, { error: t }),
          CartAPI._onError(t);
      }
    } else console.error("Invalid form in CartAPI call");
  }
  static async change(e) {
    CartAPI._trigger(CartAPI._events.update.before);
    try {
      let t = await fetch("/cart/change.js", {
        method: "POST",
        body: JSON.stringify(e),
        ...CartAPI._fetchConfig,
      });
      if (((t = await t.json()), t.status)) throw t;
      return CartAPI._trigger(CartAPI._events.update.complete, { cart: t }), t;
    } catch (t) {
      CartAPI._trigger(CartAPI._events.update.error, { error: t }),
        CartAPI._onError(t);
    }
  }
  static async update(e) {
    CartAPI._trigger(CartAPI._events.update.before);
    try {
      let t = await fetch("/cart/update.js", {
        method: "POST",
        body: JSON.stringify(e),
        ...CartAPI._fetchConfig,
      });
      if (((t = await t.json()), t.status)) throw t;
      return CartAPI._trigger(CartAPI._events.update.complete, { cart: t }), t;
    } catch (t) {
      CartAPI._trigger(CartAPI._events.update.error, { error: t }),
        CartAPI._onError(t);
    }
  }
  static async clear() {
    CartAPI._trigger(CartAPI._events.update.before);
    try {
      let t = await fetch("/cart/clear.js", {
        method: "POST",
        ...CartAPI._fetchConfig,
      });
      if (((t = await t.json()), t.status)) throw data;
      return CartAPI._trigger(CartAPI._events.update.complete, { cart: t }), t;
    } catch (t) {
      CartAPI._trigger(CartAPI._events.update.error, { error: t }),
        CartAPI._onError(t);
    }
  }
  static _onError(t) {
    console.error(`CartApi Error: 
        status: ${t.status}
        message: ${t.message}
        description: ${t.description}`);
  }
  static _trigger(t, e = {}) {
    document.dispatchEvent(new CustomEvent(t, { detail: e }));
  }
}
(CartAPI._fetchConfig = {
  credentials: "same-origin",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/javascript",
  },
}),
  (CartAPI._events = {
    update: {
      before: "cart:update:before",
      complete: "cart:update:complete",
      error: "cart:update:error",
    },
    fetch: {
      before: "cart:fetch:before",
      complete: "cart:fetch:complete",
      error: "cart:fetch:error",
    },
    add: {
      before: "cart:add:before",
      complete: "cart:add:complete",
      error: "cart:add:error",
    },
  });
class FocusableWidget extends HTMLElement {
  constructor(t = {}) {
    if ((super(), !t.name))
      throw new Error(`Focusable Widget(${t.name}) must have a name`);
    if (!this.id) throw new Error(`${t.name} must have an id`);
    if (!t.background)
      throw new Error(`Focusable Widget(${t.name}) must have a background`);
    (this._clientConfig = t), this._init(t);
  }
  open() {
    if (!this._isOpen) return this._closeFocusableWidgets(), this.toggle();
  }
  close() {
    if (this._isOpen) return this.toggle();
  }
  toggle() {
    return (
      theme.utils.prepareTransition(this),
      this._toggleClasses(),
      this._toggleAccessibilityAttributes(),
      this._isOpen
        ? (theme.utils.a11y.removeTrapFocus(this),
          this._unbindEvents(),
          this._dispatchEvents(this._events.close, ["close"]))
        : (theme.utils.a11y.trapFocus(
            this,
            this.querySelector(this.getAttribute("close"))
          ),
          this._bindEvents(),
          this._dispatchEvents(this._events.open, ["open"])),
      (this._isOpen = !this._isOpen),
      this
    );
  }
  reinitWidget() {
    this._init(this._clientConfig);
  }
  get isOpen() {
    return this._isOpen;
  }
  _init({
    name: t,
    background: e,
    widgetOpenClasses: s = [],
    bodyOpenClasses: r = [],
    attributes: i = {},
  }) {
    (this._name = t),
      (this._isOpen = !1),
      (this._selectors = {
        background: e,
        open: this.getAttribute("open"),
        close: this.getAttribute("close"),
      }),
      (this._nodes = {
        background: document.querySelector(this._selectors.background),
      }),
      (this._events = {
        open: ["focusable-widget:open", `${t}:open`, `${this.id}:open`],
        close: ["focusable-widget:close", `${t}:close`, `${this.id}:close`],
      }),
      (this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: {
          "data-focusable-widget": "true",
          "aria-hidden": "true",
          tabindex: 0,
          ...i,
        },
        widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
        bodyOpenClasses: [
          "js-focusable-widget-open",
          `js-${t}-open`,
          this.getAttribute("body-open-class"),
        ].concat(r),
      }),
      this._validateConfig(),
      this._addAccessibilityAttributes(),
      this._setupListeners();
  }
  _validateConfig() {
    if (
      ((this._config.open && this._config.open.length) ||
        console.warn(
          `WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`
        ),
      !this._config.close || !this._config.close.length)
    )
      throw new Error(
        `${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`
      );
  }
  _setupListeners() {
    this._config.open.forEach((t) =>
      t.addEventListener("click", this._open.bind(this))
    ),
      this._config.close.forEach((t) =>
        t.addEventListener("click", this._close.bind(this))
      ),
      this.addEventListener("click", (t) => t.stopPropagation());
  }
  _open(t) {
    t && (t.preventDefault(), t.stopPropagation()), this.open();
  }
  _close = (t) => {
    t && (t.preventDefault(), t.stopPropagation()), this.close();
  };
  _closeFocusableWidgets() {
    const t = document.querySelectorAll("[data-focusable-widget].open");
    t.forEach((t) => t.close());
  }
  _dispatchEvents(t, e) {
    t.forEach((t) => document.dispatchEvent(new CustomEvent(t))),
      e && e.length && e.forEach((t) => this.dispatchEvent(new CustomEvent(t)));
  }
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp),
      this._nodes.background.addEventListener("click", this._close),
      this._nodes.background.addEventListener("touchmove", this._onTouchMove);
  }
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp),
      this._nodes.background.removeEventListener("click", this._close),
      this._nodes.background.removeEventListener(
        "touchmove",
        this._onTouchMove
      );
  }
  _toggleClasses() {
    this._isOpen
      ? (this._config.bodyOpenClasses.forEach((t) => {
          t && document.body.classList.remove(t);
        }),
        this._config.widgetOpenClasses.forEach((t) => {
          t && this.classList.remove(t);
        }))
      : (this._config.bodyOpenClasses.forEach((t) => {
          t && document.body.classList.add(t);
        }),
        this._config.widgetOpenClasses.forEach((t) => {
          t && this.classList.add(t);
        }));
  }
  _toggleAccessibilityAttributes() {
    this._isOpen
      ? (this.setAttribute("aria-hidden", "true"),
        this.setAttribute("tabindex", "-1"),
        this._config.open.forEach((t) =>
          t.setAttribute("aria-expanded", "false")
        ),
        this._config.close.forEach((t) =>
          t.setAttribute("aria-expanded", "false")
        ))
      : (this.setAttribute("aria-hidden", "false"),
        this.setAttribute("tabindex", "0"),
        this._config.open.forEach((t) =>
          t.setAttribute("aria-expanded", "true")
        ),
        this._config.close.forEach((t) =>
          t.setAttribute("aria-expanded", "true")
        ));
  }
  _addAccessibilityAttributes() {
    var t = (t) => {
      t.setAttribute("tabindex", "0"),
        t.setAttribute("aria-expanded", "false"),
        t.setAttribute("aria-controls", this.id);
    };
    for (const e in this._config.attributes)
      this.setAttribute(e, this._config.attributes[e]);
    this._config.open.forEach(t), this._config.close.forEach(t);
  }
  _onKeyUp = (t) => {
    "ESCAPE" === t.code.toUpperCase() && this.close();
  };
  _onTouchMove = () => !1;
}
(theme.CartAPI = window.CartAPI = CartAPI),
  (theme.AjaxCart = document.querySelector("s-ajaxcart"));
class AnnouncementBar extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        marquee: "[js-marquee]",
        original: "[js-original]",
      });
  }
  connectedCallback() {
    this._initMarquee();
  }
  _initMarquee() {
    const t = this.querySelector(this._selectors.marquee),
      e = [...this.querySelectorAll(this._selectors.original)];
    var s = e.reduce((t, e) => t + e.offsetWidth, 0);
    t.animate(
      [{ transform: "translateX(0)" }, { transform: `translateX(-${s}px)` }],
      { duration: 4e3 * e.length, iterations: 1 / 0 }
    );
  }
}
class Drawer extends FocusableWidget {
  constructor() {
    super({ name: "drawer", background: ".drawer-background" });
    var t = this.getAttribute("position");
    if (!t) throw new Error("drawer must have position attribute");
    (this._position = t),
      this._config.bodyOpenClasses.push(`js-drawer-${t}-open`);
  }
  get position() {
    return this._position;
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({ name: "modal", background: ".modal-background" }),
      this._config.bodyOpenClasses.push("js-modal-open");
  }
}
class Accordion extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        accordion: "[js-accordion]",
        accordionItem: "[js-accordion-item]",
        accordionHeader: "[js-accordion-header]",
        accordionContent: "[js-accordion-content]",
      });
  }
  connectedCallback() {
    (this.buttons = this.querySelectorAll(this._selectors.accordionHeader)),
      this.buttons.forEach((t) => {
        t.addEventListener("click", this._toggleContent);
      }),
      (this.content = this.querySelectorAll(this._selectors.accordionContent));
  }
  _toggleContent = (t) => {
    t.stopImmediatePropagation();
    const e = t.currentTarget;
    t = this.querySelector(`#${e.getAttribute("aria-controls")}`);
    const s = theme.utils.getSiblings(
      e.parentElement,
      this._selectors.accordionItem
    );
    "false" == e.getAttribute("aria-expanded")
      ? (e.setAttribute("aria-expanded", !0),
        theme.utils.prepareTransition(t),
        this._expandSection(t),
        (this.dataset.manualCollapse &&
          "false" != this.dataset.manualCollapse) ||
          s.forEach((t) => {
            const e = t.querySelector(this._selectors.accordionHeader);
            t = t.querySelector(`#${e.getAttribute("aria-controls")}`);
            "true" == e.getAttribute("aria-expanded") &&
              (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
          }))
      : (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
  };
  _collapseSection(t) {
    t.setAttribute("aria-hidden", !0);
  }
  _expandSection(t) {
    t.setAttribute("aria-hidden", !1);
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this._elements = {
      tabs: this.querySelectorAll("[js-tab]"),
      tabList: this.querySelectorAll("[js-tab-list]"),
      tabPanel: this.querySelectorAll("[js-tab-panel]"),
    }),
      this._tabEventListener(),
      this._tabListListener();
  }
  _tabEventListener = () => {
    const t = this._elements["tabs"];
    t.forEach((t) => t.addEventListener("click", this._showTabPanel));
  };
  _showTabPanel = (t) => {
    const e = this._elements["tabs"];
    for (let t = 0; t < e.length; t++)
      e[t].setAttribute("aria-selected", "false");
    t.target.setAttribute("aria-selected", "true");
    var t = t.target.getAttribute("aria-controls"),
      s = document.querySelectorAll("[role=tabpanel]");
    for (let t = 0; t < s.length; t++) s[t].setAttribute("aria-hidden", "true");
    document.getElementById(t).setAttribute("aria-hidden", "false");
  };
  _tabListListener = () => {
    const t = this._elements["tabList"];
    t.forEach((t) => t.addEventListener("keydown", this._tabListKeydown));
  };
  _tabListKeydown = (t) => {
    37 == t.keyCode &&
      ($("[aria-selected=true]").prev().click().focus(), t.preventDefault()),
      38 == t.keyCode &&
        ($("[aria-selected=true]").prev().click().focus(), t.preventDefault()),
      39 == t.keyCode &&
        ($("[aria-selected=true]").next().click().focus(), t.preventDefault()),
      40 == t.keyCode &&
        ($("[aria-selected=true]").next().click().focus(), t.preventDefault());
  };
}
class Carousel extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        carousel: "[js-carousel]",
        slide: "[js-carousel-slide]",
        dots: "[js-carousel-dots]",
        prevButton: "[js-prev-button]",
        nextButton: "[js-next-button]",
      }),
      (this.options = {
        imagesLoaded: !0,
        contain: !0,
        pageDots: !1,
        prevNextButtons: !1,
        lazyLoad: !0,
        cellSelector: this.selectors.slide,
        wrapAround: !0,
        on: { ready: this._onReady },
      });
    var t = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    this.options = Object.assign(this.options, t);
  }
  connectedCallback() {
    this._initCarousel();
  }
  _initCarousel() {
    (this.dots = this.querySelector(this.selectors.dots)),
      this.dots && (this.eachDot = this.dots.querySelectorAll("button")),
      (this.prevButton = this.querySelector(this.selectors.prevButton)),
      (this.nextButton = this.querySelector(this.selectors.nextButton)),
      void 0 !== this.dataset.init
        ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
            match: function () {
              (this.carousel = new Flickity(
                this.querySelector(this.selectors.carousel),
                this.options
              )),
                this._initCarouselControls();
            }.bind(this),
            unmatch: function () {
              this.carousel.element.classList.contains("flickity-enabled") &&
                this.carousel.destroy();
            }.bind(this),
          })
        : ((this.carousel = new Flickity(
            this.querySelector(this.selectors.carousel),
            this.options
          )),
          this._initCarouselControls());
  }
  _initCarouselControls() {
    this.dots &&
      (this.carousel.on("change", this._updateDots),
      this.eachDot.forEach((t) => {
        t.addEventListener("click", this._onDotClick);
      })),
      this.prevButton &&
        this.prevButton.addEventListener("click", this._onPrevClick),
      this.nextButton &&
        this.nextButton.addEventListener("click", this._onNextClick);
  }
  _onReady = () => {
    this.dots && this._updateDots(0);
  };
  _updateDots = (t) => {
    this.eachDot.forEach((t) => {
      t.classList.remove("selected");
    }),
      this.dots
        .querySelector('[data-index="' + t + '"]')
        .classList.add("selected");
  };
  _onDotClick = (t) => {
    var e = t.currentTarget,
      t = e.dataset.index;
    this.carousel.select(t, !0, !1),
      this.eachDot.forEach((t) => {
        t.classList.remove("selected");
      }),
      e.classList.add("selected");
  };
  _onPrevClick = () => {
    this.carousel.previous();
  };
  _onNextClick = () => {
    this.carousel.next();
  };
}
class ProductOptions extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        singleOptionSelector: "[js-product-option-selector]",
        carousel: "[js-carousel]",
        optionName: "[js-product-option-name]",
        tags: "[js-tag]",
        ingredientsContainer: "[js-ingredients]",
        colordesContainer: "[js-colordes]",
      }),
      (this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      });
  }
  connectedCallback() {
    var t;
    (this._handle = this.dataset.productHandle),
      (this._checkAvailableOptions = !this.hasAttribute(
        "data-disable-option-binding"
      )),
      (this._tags = [...document.querySelectorAll(this._selectors.tags)]),
      (this._optionSelectors = [
        ...document.querySelectorAll(this._selectors.singleOptionSelector),
      ]),
      (this._optionNames = [
        ...document.querySelectorAll(this._selectors.optionName),
      ]),
      (this._ingredientsContainer = document.querySelector(
        this._selectors.ingredientsContainer
      )),
      (this._carousel = new Flickity(this._selectors.carousel)),
      (this._colordesContainer = document.querySelector(
        this._selectors.colordesContainer
      )),
      this._checkAvailableOptions &&
        ((this._availableValues = {}),
        (this._lastSelectedOption = null),
        (this._option1Values = this._option2Values = null)),
      !this.dataset.product ||
        ((t = document.getElementById(this.dataset.product)) &&
          (this._product = JSON.parse(t.innerHTML))),
      this._product &&
        ((this._currentVariant = this._getVariantFromOptions()),
        this._checkAvailableOptions &&
          this._setupOptionsAvailability(this._product)),
      this.dataset.masterSelectId &&
        ((this._masterSelect = document.getElementById(
          this.dataset.masterSelectId
        )),
        this._updateMasterSelect(this._currentVariant),
        (this._selectedMasterOption =
          this._masterSelect.options[this._masterSelect.selectedIndex]),
        this._handleTagChange(this._selectedMasterOption),
        this._handleIngredientsChange(this._selectedMasterOption),
        this._handleColordesChange(this._selectedMasterOption)),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(t) {
    (this._product = t), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((t) =>
      t.addEventListener("change", this._handleOptionChange)
    );
  }
  _getVariantFromOptions() {
    //console.log(this.dataset.colid + " dsds");
    if (this._product) {
      const t = this._getCurrentOptions(),
        e = this._product["variants"];
      return e.find((e) => t.every((t) => t.value === e[t.index]));
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((t) => {
        var e = t.getAttribute("type");
        const s = {};
        return (
          (("radio" !== e && "checkbox" !== e) || !!t.checked) &&
          ((s.value = t.value), (s.index = t.dataset.index), s)
        );
      })
      .filter((t) => t);
  }
  _setupOptionsAvailability(t) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      t.variants.forEach((t) => {
        var { option1: e, option2: t } = t;
        e && this._option1Values.add(e), t && this._option2Values.add(t);
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      (this._availableValues = this._getAvailableValues(this._product)),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = async (t) => {
    this._product ||
      ((this._product = await this._fetchProduct(this._handle)),
      this._checkAvailableOptions &&
        this._setupOptionsAvailability(this._product)),
      (this._lastSelectedOption = {
        key: t.target.dataset.index,
        value: t.target.value,
      });
    var e,
      s = this._getVariantFromOptions();
    this.dispatchEvent(
      new CustomEvent(this._events.change, {
        detail: { variant: s, priceChange: this._hasPriceChanged(s) },
        bubbles: !0,
      })
    ),
      this._checkAvailableOptions &&
        ((e = this._getAvailableValues(
          this._product,
          this._lastSelectedOption
        )),
        (t = this._getDifference(this._availableValues, e)),
        this._refreshValuesUI(t),
        (this._availableValues = e));
    const r = this._optionNames.find(
      (t) => t.dataset.index == this._lastSelectedOption.key
    );

    $(
      ".product_metafield_des_img_with_text .custom-content-container .content"
    ).html($(".product-swatch__group input:checked").data("ingredients"));
    null != r && (r.innerText = this._lastSelectedOption.value),
      this.hasAttribute("data-enable-history-state") &&
        this._updateHistoryState(s),
      this._masterSelect && this._updateMasterSelect(s),
      this._handleColordesChange(this._selectedMasterOption),
      this._handleTagChange(this._selectedMasterOption),
      this._handleIngredientsChange(this._selectedMasterOption),
      (this._currentVariant = s);
  };
  _hasPriceChanged(t) {
    if (t)
      return !(
        t.price === this._currentVariant?.price &&
        t.compare_at_price === this._currentVariant?.compare_at_price
      );
  }
  _getAvailableValues(s, r) {
    if (r) {
      const i = {},
        e = ["option1", "option2"];
      var t = { option1: this._option1Values, option2: this._option2Values };
      const a = e.find((t) => t !== r.key),
        n = t[a];
      return (
        n.forEach((e) => {
          var t = s.variants.findIndex(
            (t) => t[r.key] === r.value && t[a] === e && t.available
          );
          i[e] = 0 <= t;
        }),
        i
      );
    }
    return s.variants.reduce((t, e) => {
      var { option1: s, option2: e } = e;
      return s && (t[s] = !0), e && (t[e] = !0), t;
    }, {});
  }
  _refreshValuesUI(t) {
    for (const e in t) {
      const s = this.querySelector(`[value="${e}"]`);
      s && s.getAttribute("type");
    }
  }
  _updateHistoryState(t) {
    history.replaceState &&
      t &&
      ((t =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        t.id),
      window.history.replaceState({ path: t }, "", t));
  }
  _updateMasterSelect(t) {
    t && (this._masterSelect.value = t.id),
      (this._selectedMasterOption =
        this._masterSelect.options[this._masterSelect.selectedIndex]);
  }
  async _fetchProduct(t) {
    this.dispatchEvent(
      new CustomEvent(this._events.fetchBefore, { bubbles: !0 })
    );
    try {
      const s = await fetch(`/products/${t}.js`);
      var e = await s.json();
      return (
        this.dispatchEvent(
          new CustomEvent(this._events.fetchAfter, { bubbles: !0 })
        ),
        e
      );
    } catch (t) {
      this.dispatchEvent(
        new CustomEvent(this._events.fetchError, {
          details: { error: t },
          bubbles: !0,
        })
      );
    }
  }
  _handleTagChange(t) {
    const e = t.getAttribute("data-tag");
    let s = null;
    this._tags.forEach((t) => {
      (t.style.display = "none"), t.getAttribute("data-tag") == e && (s = t);
    }),
      null != s && (s.style.display = "inline-block");
  }
  _handleColordesChange(t) {
    const metacolor = t.getAttribute("data-colordes");
    if (metacolor == "") {
      $(".metacolordescription").html("");
    } else {
      // console.log("data===" + metacolor);
      $(".metacolordescription").html("(" + metacolor + ")");
    }
  }

  _handleIngredientsChange(t) {
    t = t.getAttribute("data-ingredients");
    let e = document.createElement("div");
    if (this._ingredientsContainer) {
      (e.innerHTML = t),
        (this._ingredientsContainer.innerHTML = ""),
        this._ingredientsContainer.appendChild(e);
    }
  }
  _getDifference(t, e) {
    const s = {};
    for (const r in e) e[r] !== t?.[r] && (s[r] = e[r]);
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((t) =>
      t.removeEventListener("change", this._handleOptionChange)
    );
  }
}

class ProductOptionsupsell extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        singleOptionSelector: "[js-product-option-selector-upsell]",
        carousel: "[js-carousel]",
        optionName: "[js-product-option-name-upsell]",
        tags: "[js-tag]",
        ingredientsContainer: "[js-ingredients]",
        colordesContainer: "[js-colordes]",
      }),
      (this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      });
  }
  connectedCallback() {
    var t;
    (this._handle = this.dataset.productHandle),
      (this._checkAvailableOptions = !this.hasAttribute(
        "data-disable-option-binding"
      )),
      (this._tags = [...document.querySelectorAll(this._selectors.tags)]),
      (this._optionSelectors = [
        ...document.querySelectorAll(this._selectors.singleOptionSelector),
      ]),
      (this._optionNames = [
        ...document.querySelectorAll(this._selectors.optionName),
      ]),
      (this._ingredientsContainer = document.querySelector(
        this._selectors.ingredientsContainer
      )),
      (this._carousel = new Flickity(this._selectors.carousel)),
      (this._colordesContainer = document.querySelector(
        this._selectors.colordesContainer
      )),
      this._checkAvailableOptions &&
        ((this._availableValues = {}),
        (this._lastSelectedOption = null),
        (this._option1Values = this._option2Values = null)),
      !this.dataset.product ||
        ((t = document.getElementById(this.dataset.product)) &&
          (this._product = JSON.parse(t.innerHTML))),
      this._product &&
        ((this._currentVariant = this._getVariantFromOptions()),
        this._checkAvailableOptions &&
          this._setupOptionsAvailability(this._product)),
      this.dataset.masterSelectId &&
        ((this._masterSelect = document.getElementById(
          this.dataset.masterSelectId
        )),
        this._updateMasterSelect(this._currentVariant),
        (this._selectedMasterOption =
          this._masterSelect.options[this._masterSelect.selectedIndex]),
        this._handleTagChange(this._selectedMasterOption),
        this._handleIngredientsChange(this._selectedMasterOption),
        this._handleColordesChange(this._selectedMasterOption)),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(t) {
    (this._product = t), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((t) =>
      t.addEventListener("change", this._handleOptionChange)
    );
  }
  _getVariantFromOptions() {
    // console.log(this.dataset.colid + " dsds");
    if (this._product) {
      const t = this._getCurrentOptions(),
        e = this._product["variants"];
      return e.find((e) => t.every((t) => t.value === e[t.index]));
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((t) => {
        var e = t.getAttribute("type");
        const s = {};
        return (
          (("radio" !== e && "checkbox" !== e) || !!t.checked) &&
          ((s.value = t.value), (s.index = t.dataset.index), s)
        );
      })
      .filter((t) => t);
  }
  _setupOptionsAvailability(t) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      t.variants.forEach((t) => {
        var { option1: e, option2: t } = t;
        e && this._option1Values.add(e), t && this._option2Values.add(t);
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      (this._availableValues = this._getAvailableValues(this._product)),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = async (t) => {
    this._product ||
      ((this._product = await this._fetchProduct(this._handle)),
      this._checkAvailableOptions &&
        this._setupOptionsAvailability(this._product)),
      (this._lastSelectedOption = {
        key: t.target.dataset.index,
        value: t.target.value,
      });
    var e,
      s = this._getVariantFromOptions();
    this.dispatchEvent(
      new CustomEvent(this._events.change, {
        detail: { variant: s, priceChange: this._hasPriceChanged(s) },
        bubbles: !0,
      })
    ),
      this._checkAvailableOptions &&
        ((e = this._getAvailableValues(
          this._product,
          this._lastSelectedOption
        )),
        (t = this._getDifference(this._availableValues, e)),
        this._refreshValuesUI(t),
        (this._availableValues = e));
    const r = this._optionNames.find(
      (t) => t.dataset.index == this._lastSelectedOption.key
    );

    $(
      ".product_metafield_des_img_with_text .custom-content-container .content"
    ).html($(".product-swatch__group input:checked").data("ingredients"));
    null != r && (r.innerText = this._lastSelectedOption.value),
      this.hasAttribute("data-enable-history-state") &&
        this._updateHistoryState(s),
      this._masterSelect && this._updateMasterSelect(s),
      this._handleColordesChange(this._selectedMasterOption),
      this._handleTagChange(this._selectedMasterOption),
      this._handleIngredientsChange(this._selectedMasterOption),
      (this._currentVariant = s);
  };
  _hasPriceChanged(t) {
    if (t)
      return !(
        t.price === this._currentVariant?.price &&
        t.compare_at_price === this._currentVariant?.compare_at_price
      );
  }
  _getAvailableValues(s, r) {
    if (r) {
      const i = {},
        e = ["option1", "option2"];
      var t = { option1: this._option1Values, option2: this._option2Values };
      const a = e.find((t) => t !== r.key),
        n = t[a];
      return (
        n.forEach((e) => {
          var t = s.variants.findIndex(
            (t) => t[r.key] === r.value && t[a] === e && t.available
          );
          i[e] = 0 <= t;
        }),
        i
      );
    }
    return s.variants.reduce((t, e) => {
      var { option1: s, option2: e } = e;
      return s && (t[s] = !0), e && (t[e] = !0), t;
    }, {});
  }
  _refreshValuesUI(t) {
    for (const e in t) {
      const s = this.querySelector(`[value="${e}"]`);
      s && s.getAttribute("type");
    }
  }
  _updateHistoryState(t) {
    history.replaceState &&
      t &&
      ((t =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        t.id),
      window.history.replaceState({ path: t }, "", t));
  }
  _updateMasterSelect(t) {
    t && (this._masterSelect.value = t.id),
      (this._selectedMasterOption =
        this._masterSelect.options[this._masterSelect.selectedIndex]);
  }
  async _fetchProduct(t) {
    this.dispatchEvent(
      new CustomEvent(this._events.fetchBefore, { bubbles: !0 })
    );
    try {
      const s = await fetch(`/products/${t}.js`);
      var e = await s.json();
      return (
        this.dispatchEvent(
          new CustomEvent(this._events.fetchAfter, { bubbles: !0 })
        ),
        e
      );
    } catch (t) {
      this.dispatchEvent(
        new CustomEvent(this._events.fetchError, {
          details: { error: t },
          bubbles: !0,
        })
      );
    }
  }
  _handleTagChange(t) {
    const e = t.getAttribute("data-tag");
    let s = null;
    this._tags.forEach((t) => {
      (t.style.display = "none"), t.getAttribute("data-tag") == e && (s = t);
    }),
      null != s && (s.style.display = "inline-block");
  }
  _handleColordesChange(t) {
    const metacolor = t.getAttribute("data-colordes");
    if (metacolor == "") {
      $(".metacolordescription").html("");
    } else {
      // console.log("data===" + metacolor);
      $(".metacolordescription").html("(" + metacolor + ")");
    }
  }

  _handleIngredientsChange(t) {
    t = t.getAttribute("data-ingredients");
    let e = document.createElement("div");
    if (this._ingredientsContainer) {
      (e.innerHTML = t),
        (this._ingredientsContainer.innerHTML = ""),
        this._ingredientsContainer.appendChild(e);
    }
  }
  _getDifference(t, e) {
    const s = {};
    for (const r in e) e[r] !== t?.[r] && (s[r] = e[r]);
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((t) =>
      t.removeEventListener("change", this._handleOptionChange)
    );
  }
}

class ProductOptionsQv extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        singleOptionSelector:
          "[js-product-option-selector-" + this.dataset.colid + "]",
        carousel: "[js-carousel]",
        optionName: "[js-product-option-name-" + this.dataset.colid + "]",
        tags: "[js-tag]",
        ingredientsContainer: "[js-ingredients]",
      }),
      (this._events = {
        change: "variant:change",
        fetchBefore: "variant:fetch:before",
        fetchAfter: "variant:fetch:after",
        fetchError: "variant:fetch:error",
      });
  }
  connectedCallback() {
    var t;
    (this._handle = this.dataset.productHandle),
      (this._checkAvailableOptions = !this.hasAttribute(
        "data-disable-option-binding"
      )),
      (this._tags = [...document.querySelectorAll(this._selectors.tags)]),
      (this._optionSelectors = [
        ...document.querySelectorAll(this._selectors.singleOptionSelector),
      ]),
      (this._optionNames = [
        ...document.querySelectorAll(this._selectors.optionName),
      ]),
      (this._ingredientsContainer = document.querySelector(
        this._selectors.ingredientsContainer
      )),
      (this._colordesContainer = document.querySelector(
        this._selectors.colordesContainer
      )),
      (this._carousel = new Flickity(this._selectors.carousel)),
      this._checkAvailableOptions &&
        ((this._availableValues = {}),
        (this._lastSelectedOption = null),
        (this._option1Values = this._option2Values = null)),
      !this.dataset.product ||
        ((t = document.getElementById(this.dataset.product)) &&
          (this._product = JSON.parse(t.innerHTML))),
      this._product &&
        ((this._currentVariant = this._getVariantFromOptions()),
        this._checkAvailableOptions &&
          this._setupOptionsAvailability(this._product)),
      this.dataset.masterSelectId &&
        ((this._masterSelect = document.getElementById(
          this.dataset.masterSelectId
        )),
        this._updateMasterSelect(this._currentVariant),
        (this._selectedMasterOption =
          this._masterSelect.options[this._masterSelect.selectedIndex]),
        this._handleTagChange(this._selectedMasterOption),
        this._handleColordesChange(this._selectedMasterOption),
        this._handleIngredientsChange(this._selectedMasterOption)),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(t) {
    (this._product = t), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((t) =>
      t.addEventListener("change", this._handleOptionChange)
    );
  }
  _getVariantFromOptions() {
    //console.log(this._selectors.singleOptionSelector + " dsds");
    if (this._product) {
      const t = this._getCurrentOptions(),
        e = this._product["variants"];
      return e.find((e) => t.every((t) => t.value === e[t.index]));
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((t) => {
        var e = t.getAttribute("type");
        const s = {};
        return (
          (("radio" !== e && "checkbox" !== e) || !!t.checked) &&
          ((s.value = t.value), (s.index = t.dataset.index), s)
        );
      })
      .filter((t) => t);
  }
  _setupOptionsAvailability(t) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      t.variants.forEach((t) => {
        var { option1: e, option2: t } = t;
        e && this._option1Values.add(e), t && this._option2Values.add(t);
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      (this._availableValues = this._getAvailableValues(this._product)),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = async (t) => {
    this._product ||
      ((this._product = await this._fetchProduct(this._handle)),
      this._checkAvailableOptions &&
        this._setupOptionsAvailability(this._product)),
      (this._lastSelectedOption = {
        key: t.target.dataset.index,
        value: t.target.value,
      });
    var e,
      s = this._getVariantFromOptions();
    this.dispatchEvent(
      new CustomEvent(this._events.change, {
        detail: { variant: s, priceChange: this._hasPriceChanged(s) },
        bubbles: !0,
      })
    ),
      this._checkAvailableOptions &&
        ((e = this._getAvailableValues(
          this._product,
          this._lastSelectedOption
        )),
        (t = this._getDifference(this._availableValues, e)),
        this._refreshValuesUI(t),
        (this._availableValues = e));
    const r = this._optionNames.find(
      (t) => t.dataset.index == this._lastSelectedOption.key
    );
    null != r && (r.innerText = this._lastSelectedOption.value),
      this.hasAttribute("data-enable-history-state") &&
        this._updateHistoryState(s),
      this._masterSelect && this._updateMasterSelect(s),
      this._handleTagChange(this._selectedMasterOption),
      this._handleColordesChange(this._selectedMasterOption),
      this._handleIngredientsChange(this._selectedMasterOption),
      (this._currentVariant = s);
  };
  _hasPriceChanged(t) {
    if (t)
      return !(
        t.price === this._currentVariant?.price &&
        t.compare_at_price === this._currentVariant?.compare_at_price
      );
  }
  _getAvailableValues(s, r) {
    if (r) {
      const i = {},
        e = ["option1", "option2"];
      var t = { option1: this._option1Values, option2: this._option2Values };
      const a = e.find((t) => t !== r.key),
        n = t[a];
      return (
        n.forEach((e) => {
          var t = s.variants.findIndex(
            (t) => t[r.key] === r.value && t[a] === e && t.available
          );
          i[e] = 0 <= t;
        }),
        i
      );
    }
    return s.variants.reduce((t, e) => {
      var { option1: s, option2: e } = e;
      return s && (t[s] = !0), e && (t[e] = !0), t;
    }, {});
  }
  _refreshValuesUI(t) {
    for (const e in t) {
      const s = this.querySelector(`[value="${e}"]`);
      s && s.getAttribute("type");
    }
  }
  _updateHistoryState(t) {
    history.replaceState &&
      t &&
      ((t =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        t.id),
      window.history.replaceState({ path: t }, "", t));
  }
  _updateMasterSelect(t) {
    t && (this._masterSelect.value = t.id),
      (this._selectedMasterOption =
        this._masterSelect.options[this._masterSelect.selectedIndex]);
  }
  async _fetchProduct(t) {
    this.dispatchEvent(
      new CustomEvent(this._events.fetchBefore, { bubbles: !0 })
    );
    try {
      const s = await fetch(`/products/${t}.js`);
      var e = await s.json();
      return (
        this.dispatchEvent(
          new CustomEvent(this._events.fetchAfter, { bubbles: !0 })
        ),
        e
      );
    } catch (t) {
      this.dispatchEvent(
        new CustomEvent(this._events.fetchError, {
          details: { error: t },
          bubbles: !0,
        })
      );
    }
  }
  _handleTagChange(t) {
    const e = t.getAttribute("data-tag");
    let s = null;
    this._tags.forEach((t) => {
      (t.style.display = "none"), t.getAttribute("data-tag") == e && (s = t);
    }),
      null != s && (s.style.display = "inline-block");
  }

  _handleColordesChange(t) {
    const metacolor = t.getAttribute("data-colordes");
    if (metacolor == "") {
      $(".metacolordescription").html("");
    } else {
      //console.log("data===" + metacolor);
      $(".metacolordescription").html("(" + metacolor + ")");
    }
  }

  _handleIngredientsChange(t) {
    t = t.getAttribute("data-ingredients");
    let e = document.createElement("div");
    (e.innerHTML = t),
      (this._ingredientsContainer.innerHTML = ""),
      this._ingredientsContainer.appendChild(e);
  }
  _getDifference(t, e) {
    const s = {};
    for (const r in e) e[r] !== t?.[r] && (s[r] = e[r]);
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((t) =>
      t.removeEventListener("change", this._handleOptionChange)
    );
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((t) =>
        t.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(t) {
    t.preventDefault();
    var e = this.input.value;
    "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    const t = document.createElement("template");
    (t.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
      }

      :host([loading]) {
        display: block;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'inherit');
        opacity: var(--bg-opacity, 50%);
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2
      }

      .loading-spinner div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: var(--size, 5rem);
        height: var(--size, 5rem);
        margin: 0.5rem;
        border: 0.5rem solid var(--loading-color, #fff);
        border-radius: 50%;
        animation: loading-spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: var(--loading-color, #fff) transparent transparent transparent;
      }
      .loading-spinner div:nth-child(1) {
        animation-delay: -0.45s;
      }
      .loading-spinner div:nth-child(2) {
        animation-delay: -0.3s;
      }
      .loading-spinner div:nth-child(3) {
        animation-delay: -0.15s;
      }
      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner"><div></div><div></div><div></div><div></div></div>
    `),
      this.attachShadow({ mode: "open" }),
      this.shadowRoot.appendChild(t.content.cloneNode(!0));
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = this.querySelector(
        "[js-predictive-search]"
      )),
      (this.predictiveSearchRecommendations = this.querySelector(
        "[js-search-drawer-recommendations]"
      )),
      this.input.addEventListener(
        "input",
        theme.utils
          .debounce((t) => {
            this.onChange(t);
          }, 300)
          .bind(this)
      );
  }
  onChange() {
    var t = this.input.value.trim();
    t.length ? this.getSearchResults(t) : this.close();
  }
  getSearchResults(t) {
    fetch(
      `${routes.predictive_search_url}?q=${t}&resources[type]=product,collection,article,page&resources[limit]=4&section_id=predictive-search`
    )
      .then((t) => {
        if (t.ok) return t.text();
        t = new Error(t.status);
        throw (this.close(), t);
      })
      .then((t) => {
        t = new DOMParser()
          .parseFromString(t, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        (this.predictiveSearchResults.innerHTML = t), this.open();
      })
      .catch((t) => {
        throw (this.close(), t);
      });
  }
  open() {
    (this.predictiveSearchResults.style.display = "block"),
      (this.predictiveSearchRecommendations.style.display = "none");
  }
  close() {
    (this.predictiveSearchResults.style.display = "none"),
      (this.predictiveSearchRecommendations.style.display = "flex");
  }
}
class AjaxCart extends HTMLElement {
  constructor() {
    super(),
      this._Ajaxcart,
      (this._selectors = {
        drawer: "[js-cart-drawer]",
        upsellData: "#AjaxCartUpsellData[js-upsell-data]",
        counter: "[js-cart-counter]",
        toggleGift: "[js-toggle-note]",
      }),
      (this._internalEvents = {
        fetch: "ajaxcart:fetch",
        open: "ajaxcart:open",
        close: "ajaxcart:close",
        refreshUpsell: "ajaxcart:upsell:refresh",
      }),
      (this._config = {
        shippingThreshold: "true" === this.dataset.shippingThreshold,
      }),
      (this._drawer = document.querySelector(this._selectors.drawer)),
      this._initAjaxCart();
  }
  fetch(t = !0) {
    this.dispatchEvent(
      new CustomEvent(this._internalEvents.fetch, { detail: { openDrawer: t } })
    );
  }
  open(t = !0) {
    this.dispatchEvent(
      new CustomEvent(this._internalEvents.open, { detail: { fetch: t } })
    );
  }
  close() {
    this.dispatchEvent(new CustomEvent(this._internalEvents.close));
  }
  refreshUpsell() {
    this.dispatchEvent(new CustomEvent(this._internalEvents.refreshUpsell));
  }
  _initAjaxCart() {
    var t = new URLSearchParams(window.location.search).get("viewcart");
    (this._Ajaxcart = Vue.createApp(this._ajaxCartApp())),
      this._registerComponents(),
      this._Ajaxcart.mount("#AjaxCartTemplate"),
      this.classList.remove("hidden"),
      this._drawer.reinitWidget(),
      "true" === t && this.open();
  }
  _ajaxCartApp() {
    const t = this;
    return {
      delimiters: ["${", "}"],
      data() {
        return {
          drawer: t._drawer,
          shippingThreshold: t._config.shippingThreshold,
          cart: null,
          error: !1,
          counter: document.querySelector(t._selectors.counter),
          cartHeight: !1,
          showCartNote: !1,
          cartNote: "",
          loading: { cart: !1, item: !1 },
        };
      },
      computed: {
        handlesInCart() {
          return this.cart.items.reduce(
            (t, e) => ({ ...t, [e.handle]: !0 }),
            {}
          );
        },
        allowGift() {
          return (
            1 != this.cart.items.length ||
            7026320867514 != this.cart.items[0].product_id
          );
        },
        allowGiftNote() {
          let e = !1;
          return (
            this.cart.items.forEach((t) => {
              7334479036602 != t.product_id &&
                7026320867514 != t.product_id &&
                7337099460794 != t.product_id &&
                (e = !0);
            }),
            e
          );
        },
      },
      watch: {
        cart() {
          this.cartHeight || this.$nextTick(this.updateCartHeight);
        },
        showCartNote(t) {
          0 == t && (this.cartNote = ""), this.$nextTick(this.updateCartHeight);
        },
      },
      updated() {
        this.counter &&
          (this.cart || (this.counter.innerHTML = 0),
          (this.counter.innerHTML = this.cart.item_count));
      },
      mounted() {
        const t = document.querySelector("s-ajaxcart");
        t.addEventListener("ajaxcart:fetch", this.onFetch),
          t.addEventListener("ajaxcart:open", this.onOpen),
          t.addEventListener("ajaxcart:close", this.onClose),
          document.addEventListener("CartDrawer:open", async () => {
            this.cart || (this.cart = await this.fetchCart());
          }),
          document.addEventListener("CartDrawer:close", () => {
            this.error && (this.error = !1);
          }),
          document.addEventListener(
            "cart:add:complete",
            this.onCartAddComplete
          ),
          document.addEventListener(
            "cart:update:complete",
            this.onCartUpdateComplete
          ),
          document.addEventListener("cart:update:error", this.onCartError),
          document.addEventListener("cart:add:error", this.onCartError);
        var this2 = this;

        $(".mob-buy-look").click(function () {
          var icount = 0;
          var total = 0;
          $(this)
            .parents(".swiper-slide")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                icount = icount + 1;
                total =
                  total + Number($(this).data("price")) * Number($(this).val());
              }
            });

          //console.log("icount==" + icount);
          var disc3 = $(this).parents(".inner-slider-part").data("peroff3");
          var disc4 = $(this).parents(".inner-slider-part").data("peroff4");
          var disc5 = $(this).parents(".inner-slider-part").data("peroff5");
          var lookdisc = 0;
          if (icount == 3) {
            lookdisc = Number(disc3);
            total = total - (Number(disc3) * total) / 100;
            //console.log("lookdisc3==" + lookdisc);
          } else if (icount == 4) {
            lookdisc = Number(disc4);
            total = total - (Number(disc4) * total) / 100;
            //console.log("lookdisc4==" + lookdisc);
          } else if (icount == 5) {
            lookdisc = Number(disc5);
            total = total - (Number(disc5) * total) / 100;
            //console.log("lookdisc5==" + lookdisc);
          } else {
            //console.log("lookdisc2==" + lookdisc);
            lookdisc = 100;
          }

          var inttotal = Math.round(total / 100);
          //console.log("total=" + inttotal);
          var loader = $(this).find("loading-spinner");
          var textel = $(this).find("span");
          loader.attr("loading", "");
          textel.css("opacity", "0");
          var items = [];
          var item = {};
          item["quantity"] = 1;
          item["id"] = $(
            '.defaultbuylook[data-varprice="' + inttotal + '"'
          ).data("varid");
          item["properties"] = {};
          var pids = "";
          var pqty = "";
          $(this)
            .parents(".swiper-slide")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                pids = pids + "," + $(this).data("varid");
                pqty = pqty + "," + $(this).val();
                item["properties"][$(this).data("title")] = $(this).val();
              }
            });
          item["properties"]["_prqty"] = pqty.substring(1);
          item["properties"]["_prids"] = pids.substring(1);
          item["properties"]["_ptype"] = "buy_the_look";
          item["properties"]["_poff"] = lookdisc;
          items.push(item);
          if (items.length > 0) {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: { items: items },
              dataType: "json",
              success: function (data) {
                setTimeout(function () {
                  loader.removeAttr("loading");
                  //console.log("ADDTOCART===", data.items);
                  textel.css("opacity", "1");
                }, 2000);
                this2.onCartAddComplete();
              },
            });
          } else {
            alert("Please select at least one quatity of a product.");
          }
        });

        $(".desk-buy-look").click(function () {
          var icount = 0;
          var total = 0;
          $(this)
            .parents(".swiper-slide")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                icount = icount + 1;
                total =
                  total + Number($(this).data("price")) * Number($(this).val());
              }
            });

          //console.log("icount==" + icount);
          var disc3 = $(this).parents(".inner-slider-part").data("peroff3");
          var disc4 = $(this).parents(".inner-slider-part").data("peroff4");
          var disc5 = $(this).parents(".inner-slider-part").data("peroff5");
          var lookdisc = 0;
          if (icount == 3) {
            lookdisc = Number(disc3);
            total = total - (Number(disc3) * total) / 100;
            //console.log("lookdisc3==" + lookdisc);
          } else if (icount == 4) {
            lookdisc = Number(disc4);
            total = total - (Number(disc4) * total) / 100;
            //console.log("lookdisc4==" + lookdisc);
          } else if (icount == 5) {
            lookdisc = Number(disc5);
            total = total - (Number(disc5) * total) / 100;
            //console.log("lookdisc5==" + lookdisc);
          } else {
            //console.log("lookdisc2==" + lookdisc);
            lookdisc = 100;
          }
          var inttotal = Math.round(total / 100);
          //console.log("total=" + inttotal);
          var loader = $(this).find("loading-spinner");
          var textel = $(this).find("span");
          loader.attr("loading", "");
          textel.css("opacity", "0");
          var items = [];
          var item = {};
          item["quantity"] = 1;
          item["id"] = $(
            '.defaultbuylook[data-varprice="' + inttotal + '"'
          ).data("varid");
          item["properties"] = {};
          var pids = "";
          var pqty = "";
          $(this)
            .parents(".swiper-slide")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                pids = pids + "," + $(this).data("varid");
                pqty = pqty + "," + $(this).val();
                item["properties"][$(this).data("title")] = $(this).val();
              }
            });
          item["properties"]["_prqty"] = pqty.substring(1);
          item["properties"]["_prids"] = pids.substring(1);
          item["properties"]["_ptype"] = "buy_the_look";
          item["properties"]["_poff"] = lookdisc;
          items.push(item);
          if (items.length > 0) {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: { items: items },
              dataType: "json",
              success: function (data) {
                setTimeout(function () {
                  loader.removeAttr("loading");
                  //console.log("ADDTOCART===", data.items);
                  textel.css("opacity", "1");
                }, 2000);
                this2.onCartAddComplete();
              },
            });
          } else {
            alert("Please select at least one quatity of a product.");
          }
        });

        $(".desk-buy-look")
          .parents(".swiper-slide")
          .find(".quantity__input")
          .on("change keydown paste input", function () {
            var icount = 0;
            var total = 0;
            var disc3 = $(this).parents(".inner-slider-part").data("peroff3");
            var disc4 = $(this).parents(".inner-slider-part").data("peroff4");
            var disc5 = $(this).parents(".inner-slider-part").data("peroff5");
            $(this)
              .parents(".swiper-slide")
              .find(".quantity__input")
              .each(function () {
                if ($(this).val() != 0) {
                  icount = icount + 1;
                  total =
                    total +
                    Number($(this).data("price")) * Number($(this).val());
                }
              });

            if (icount == 3) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              total = total - (Number(disc3) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount == 4) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              total = total - (Number(disc4) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount == 5) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              total = total - (Number(disc5) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount < 3) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .hide();
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
          });

        $(".mob-buy-look")
          .parents(".swiper-slide")
          .find(".quantity__input")
          .on("change keydown paste input", function () {
            var icount = 0;
            var total = 0;
            var disc3 = $(this).parents(".inner-slider-part").data("peroff3");
            var disc4 = $(this).parents(".inner-slider-part").data("peroff4");
            var disc5 = $(this).parents(".inner-slider-part").data("peroff5");
            $(this)
              .parents(".swiper-slide")
              .find(".quantity__input")
              .each(function () {
                if ($(this).val() != 0) {
                  icount = icount + 1;
                  total =
                    total +
                    Number($(this).data("price")) * Number($(this).val());
                }
              });

            if (icount == 3) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              total = total - (Number(disc3) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount == 4) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              total = total - (Number(disc4) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount == 5) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .show();
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .html(
                  "<del>" +
                    Shopify.formatMoney(total, "${{amount_no_decimals}}") +
                    "</del>"
                );
              total = total - (Number(disc5) * total) / 100;
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
            if (icount < 3) {
              $(this)
                .parents(".inner-slider-part")
                .find(".compareamount")
                .hide();
              $(this)
                .parents(".inner-slider-part")
                .find(".totalamount")
                .html(Shopify.formatMoney(total, "${{amount_no_decimals}}"));
            }
          });

        /**==============dynamic blog post=====================**/
        $(".dynamic-bundle-button").click(function () {
          var icount = 0;
          var total = 0;
          $(this)
            .parents(".dynamic-blog-page-container")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                icount = icount + 1;
                total =
                  total + Number($(this).data("price")) * Number($(this).val());
              }
            });
          //console.log("icount==" + icount);
          var disc = $(this)
            .parents(".dynamic-bundle-container")
            .data("peroff");
          //console.log("discopunts" + disc);
          var lookdisc = 0;

          total = total - (Number(disc) * total) / 100;

          var inttotal = Math.round(total / 100);
          //console.log("total=" + inttotal);
          var loader = $(this).find("loading-spinner");
          var textel = $(this).find("span");
          loader.attr("loading", "");
          textel.css("opacity", "0");
          var items = [];
          var item = {};
          item["quantity"] = 1;
          item["id"] = $(
            '.defaultbuylook[data-varprice="' + inttotal + '"'
          ).data("varid");
          item["properties"] = {};
          var pids = "";
          var pqty = "";

          $(this)
            .parents(".dynamic-blog-page-container")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                pids = pids + "," + $(this).data("varid");
                pqty = pqty + "," + $(this).val();
                item["properties"][$(this).data("title")] = $(this).val();
              }
            });

          item["properties"]["_prqty"] = pqty.substring(1);
          item["properties"]["_prids"] = pids.substring(1);
          item["properties"]["_ptype"] = "buy_the_look";
          item["properties"]["_poff"] = lookdisc;
          items.push(item);
          if (items.length > 0) {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: { items: items },
              dataType: "json",
              success: function (data) {
                setTimeout(function () {
                  loader.removeAttr("loading");
                  //console.log("ADDTOCART===", data.items);
                  textel.css("opacity", "1");
                }, 2000);
                this2.onCartAddComplete();
              },
            });
          } else {
            alert("Something went wrong.");
          }
        });
        /**====================dynamic blog post======================**/

        $(".dynamic-bundle-button-blog").click(function () {
          var icount = 0;
          var total = 0;
          $(this)
            .parents(".dynamic-blog-product-item")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                icount = icount + 1;
                total =
                  total + Number($(this).data("price")) * Number($(this).val());
              }
            });
          //console.log("icount==" + icount);
          var disc = $(this)
            .parents(".dynamic-bundle-container")
            .data("peroff");
          //console.log("discopunts" + disc);
          var lookdisc = 0;

          total = total - (Number(disc) * total) / 100;

          var inttotal = Math.round(total / 100);
          //console.log("total=" + inttotal);
          var loader = $(this).find("loading-spinner");
          var textel = $(this).find("span");
          loader.attr("loading", "");
          textel.css("opacity", "0");
          var items = [];
          var item = {};
          item["quantity"] = 1;
          item["id"] = $(
            '.defaultbuylook[data-varprice="' + inttotal + '"'
          ).data("varid");
          item["properties"] = {};
          var pids = "";
          var pqty = "";

          $(this)
            .parents(".dynamic-blog-product-item")
            .find(".quantity__input")
            .each(function () {
              if ($(this).val() != 0) {
                pids = pids + "," + $(this).data("varid");
                pqty = pqty + "," + $(this).val();
                item["properties"][$(this).data("title")] = $(this).val();
              }
            });

          item["properties"]["_prqty"] = pqty.substring(1);
          item["properties"]["_prids"] = pids.substring(1);
          item["properties"]["_ptype"] = "buy_the_look";
          item["properties"]["_poff"] = lookdisc;
          items.push(item);
          if (items.length > 0) {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: { items: items },
              dataType: "json",
              success: function (data) {
                setTimeout(function () {
                  loader.removeAttr("loading");
                  //console.log("ADDTOCART===", data.items);
                  textel.css("opacity", "1");
                }, 2000);
                this2.onCartAddComplete();
              },
            });
          } else {
            alert("Something went wrong.");
          }
        });
      },
      methods: {
        async fetchCart() {
          this.loading.cart = !0;
          var t = await theme.CartAPI.get();
          return (this.loading.cart = !1), t;
        },
        async updateItemQuantity({ line: t, quantity: e }) {
          e < 0 ||
            ((this.loading.item = t - 1),
            (e = await theme.CartAPI.change({ line: t, quantity: e })),
            (this.cart = e || (await this.fetchCart())),
            (this.loading.item = !1));
        },
        async removeItem(t) {
          (this.loading.item = t - 1),
            await this.updateItemQuantity({ line: t, quantity: 0 }),
            (this.loading.item = !1);
        },
        async addToCart({ variantId: t, quantity: e }) {
          this.loading.cart = !0;
          e = await theme.CartAPI.add({ id: t, quantity: e });
          return (this.loading.cart = !1), e;
        },
        async onCartUpdateComplete({ detail: t }) {
          var t = t["cart"];
          (this.cart = t || (await this.fetchCart())),
            this.drawer.isOpen || this.drawer.open();

          fetch(window.location.href)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
              }
              return response.text();
            })
            .then((responseText) => {
              // Parse the full HTML document
              const parser = new DOMParser();
              const doc = parser.parseFromString(responseText, "text/html");

              // Use jQuery on parsed document
              const $doc = $(doc);

              const drawerUpsellContent = $doc.find("#upsell-cart-data").html();
              // console.log("drawerUpsellContent:", drawerUpsellContent); // ✅ DEBUG

              if (drawerUpsellContent) {
                $(".drawer-upsell-wrapper").html(drawerUpsellContent);
              } else {
                // console.warn("#upsell-cart-data not found in fetched HTML");
              }

              const productUpsellContent = $doc
                .find(".product-upsell-wrapper")
                .html();
              if (
                productUpsellContent &&
                $(".product-upsell-wrapper").length > 0
              ) {
                $(".product-upsell-wrapper").html(productUpsellContent);
              }

              document.dispatchEvent(new Event("initializeProductCard"));
            })
            .catch((error) => {
              console.error(
                "Failed to fetch and update upsell content:",
                error
              );
            });
        },
        async onCartAddComplete() {
          (this.cart = await this.fetchCart()),
            this.drawer.isOpen || this.drawer.open();

          fetch(window.location.href)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
              }
              return response.text();
            })
            .then((responseText) => {
              // Parse the full HTML document
              const parser = new DOMParser();
              const doc = parser.parseFromString(responseText, "text/html");

              // Use jQuery on parsed document
              const $doc = $(doc);

              const drawerUpsellContent = $doc.find("#upsell-cart-data").html();
              // console.log("drawerUpsellContent:", drawerUpsellContent); // ✅ DEBUG

              if (drawerUpsellContent) {
                $(".drawer-upsell-wrapper").html(drawerUpsellContent);
              } else {
                // console.warn("#upsell-cart-data not found in fetched HTML");
              }

              const productUpsellContent = $doc
                .find(".product-upsell-wrapper")
                .html();
              if (
                productUpsellContent &&
                $(".product-upsell-wrapper").length > 0
              ) {
                $(".product-upsell-wrapper").html(productUpsellContent);
              }

              document.dispatchEvent(new Event("initializeProductCard"));
            })
            .catch((error) => {
              console.error(
                "Failed to fetch and update upsell content:",
                error
              );
            });
        },
        async onFetch({ detail: t }) {
          var { openDrawer: t = !1 } = t;
          (this.cart = await this.fetchCart()), t && this.drawer.open();
        },
        async onOpen({ detail: t }) {
          var { fetch: t = !0 } = t;
          t && (this.cart = await this.fetchCart()), this.drawer.open();
        },
        onClose() {
          this.drawer.close();
        },
        onCartError({ detail: t }) {
          var t = t["error"];
          if (t)
            return "unprocessable_entity" !== t.status
              ? void (this.error =
                  "We apologize, an error occured when updating your cart.")
              : void (this.error = t.message);
        },
        formatMoney(t) {
          return theme.utils.formatMoney(t);
        },
        updateCartHeight() {
          var t = this.$refs.cartHeader.clientHeight,
            e = this.$refs.cartFooter.clientHeight;
          this.cartHeight = `calc(100vh - ${(t + e) / 16}rem)`;
        },
      },
    };
  }
  _registerComponents() {
    var t = document.querySelector(this._selectors.upsellData),
      e = document.querySelector("#AjaxCartShippingThreshold").dataset
        .threshold;
    this._registerComponent(
      "line-item",
      "#AjaxCartLineItem",
      this._Components.LineItem()
    ),
      this._registerComponent(
        "shipping-threshold",
        "#AjaxCartShippingThreshold",
        this._Components.ShippingThreshold(e)
      ),
      this._registerComponent(
        "upsell-products",
        "#AjaxCartUpsell",
        this._Components.UpsellProducts([])
      ),
      this._registerComponent(
        "upsell-product",
        "#AjaxCartUpsellProduct",
        this._Components.UpsellProduct()
      ),
      this._registerComponent(
        "skeleton-item",
        "#AjaxCartSkeletonItem",
        this._Components.SkeletonItem()
      );
  }
  _registerComponent(t, e, s) {
    const r = document.querySelector(e);
    this._Ajaxcart.component(t, { template: r.innerHTML, ...s }), r.remove();
  }
  _Components = {
    mixins() {
      return {
        methods: {
          formatMoney(t) {
            return theme.utils.formatMoney(t);
          },
          truncateString(t, e, s = "...") {
            return t.length < e ? t : t.substring(0, e) + s;
          },
          arrayIntoBooleanObject(t, s) {
            return t.reduce((t, e) => ({ ...t, [s ? e[s] : e]: !0 }), {});
          },
        },
      };
    },
    LineItem() {
      return {
        delimiters: ["${", "}"],
        mixins: [this.mixins()],
        props: ["item", "line", "loading"],
        emits: ["removeItem", "updateItemQuantity"],
      };
    },
    ShippingThreshold(t) {
      return {
        delimiters: ["${", "}"],
        mixins: [this.mixins()],
        props: ["cart"],
        data() {
          return { threshold: t };
        },
        computed: {
          amountForFreeShipping() {
            //console.log(this.cart);
            var carttotal = this.cart.total_price;
            var total_items = 0;
            var obj1 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7026320867514;
            })[0];
            if (obj1 != null) {
              total_items = total_items + obj1.quantity;
              carttotal = carttotal - obj1.price * obj1.quantity;
            }
            var obj2 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7337099460794;
            })[0];
            if (obj2 != null) {
              total_items = total_items + obj2.quantity;
              carttotal = carttotal - obj2.price * obj2.quantity;
            }
            var obj3 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7334479036602;
            })[0];
            if (obj3 != null) {
              total_items = total_items + obj3.quantity;
              carttotal = carttotal - obj3.price * obj3.quantity;
            }
            if (this.cart.item_count > total_items) {
              $(".shipping-threshold.w-full").show();
              if (this.cart) return this.threshold - carttotal;
            } else {
              //console.log("hide");
              var intervalId = window.setInterval(function () {
                if ($(".shipping-threshold.w-full").css("display") != "none") {
                  $(".shipping-threshold.w-full").css("display", "none");
                  clearInterval(intervalId);
                }
              }, 100);

              return 0;
            }
          },
          progress() {
            var carttotal = this.cart.total_price;
            var total_items = 0;
            var obj1 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7026320867514;
            })[0];
            if (obj1 != null) {
              total_items = total_items + obj1.quantity;
              carttotal = carttotal - obj1.price * obj1.quantity;
            }
            var obj2 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7337099460794;
            })[0];
            if (obj2 != null) {
              total_items = total_items + obj2.quantity;
              carttotal = carttotal - obj2.price * obj2.quantity;
            }
            var obj3 = this.cart.items.filter(function (jsonObject) {
              return jsonObject["product_id"] == 7334479036602;
            })[0];
            if (obj3 != null) {
              total_items = total_items + obj3.quantity;
              carttotal = carttotal - obj3.price * obj3.quantity;
            }
            if (this.cart.item_count > total_items) {
              $(".shipping-threshold.w-full").show();
              if (this.cart) return (carttotal / this.threshold) * 100;
            } else {
              $(".shipping-threshold.w-full").hide();
              return 0;
            }
          },
          unlocked() {
            return this.amountForFreeShipping <= 0;
          },
        },
      };
    },
    UpsellProducts(t = []) {
      const startEvent = new Event("initializeProductCard");
      document.dispatchEvent(startEvent);
      // return {
      //   delimiters: ["${", "}"],
      //   mixins: [this.mixins()],
      //   props: ["cart", "handlesInCart"],
      //   emits: ["addToCart"],
      //   data() {
      //     return {
      //       products: [],
      //       defaultProducts: [],
      //       taggedProducts: {},
      //       limit: 6,
      //       upsellTags: theme.upsellTags || [],
      //       fetching: !1,
      //       currentSlide: 0,
      //     };
      //   },
      //   computed: {
      //     tagsInCart() {
      //       if (this.cart && this.cart.items) {
      //         let e = [];
      //         return (
      //           this.cart.items.forEach((t) => {
      //             t?.properties?.upsell?.tag && e.push(t.properties.upsell.tag);
      //           }),
      //           this.arrayIntoBooleanObject(e)
      //         );
      //       }
      //     },
      //     handlesInUpsell() {
      //       return this.getHandles(this.products);
      //     },
      //   },
      //   created() {
      //     this.processParsedProducts(t);
      //   },
      //   mounted() {
      //     const t = document.querySelector("s-ajaxcart");
      //     t.addEventListener("ajaxcart:upsell:refresh", this.refreshUpsell),
      //       this.refreshUpsell();
      //   },
      //   watch: {
      //     cart(s, t) {
      //       return t && s && t?.items && s?.items
      //         ? void (
      //             t.items.some((t, e) => s?.items[e]?.handle !== t?.handle) &&
      //             this.refreshUpsell()
      //           )
      //         : this.refreshUpsell();
      //     },
      //   },
      //   updated() {
      //     setTimeout(() => this.initSlider(), 1);
      //   },
      //   methods: {
      //     initSlider() {
      //       var t = document.querySelector("[js-upsell-slider]");
      //       this.slider && this.slider.destroy(),
      //         t &&
      //           ((this.slider = new Flickity(t, {
      //             contain: !0,
      //             adaptiveHeight: !0,
      //             imagesLoaded: !0,
      //             pageDots: !1,
      //           })),
      //           this.slider.on("change", (t) => {
      //             this.currentSlide = t;
      //           }),
      //           this.products.length && this.slider.select(this.currentSlide));
      //     },
      //     async refreshUpsell() {
      //       if (this.cart && this.cart.items)
      //         try {
      //           this.removeUpsellProductsInCart(),
      //             await this.fetchUpsell(),
      //             this.products.length < this.limit &&
      //               (this.fillUpsellWithTaggedProducts(),
      //               this.fillUpsellWithDefaults());
      //         } catch (t) {
      //           console.log(t);
      //         }
      //     },
      //     async fetchUpsell() {
      //       this.products = (
      //         await this.fetchUpsellHandles(this.getUpsellHandles())
      //       ).filter((t) => t.available);
      //     },
      //     processParsedProducts(t) {
      //       t &&
      //         t.forEach((t) => {
      //           t.product &&
      //             t.tag &&
      //             t.product.available &&
      //             ((t.product.options = t.product_options),
      //             "__DEFAULT__" === t.tag
      //               ? this.defaultProducts.push(t.product)
      //               : (this.taggedProducts[t.tag] = t.product));
      //         });
      //     },
      //     fillUpsellWithTaggedProducts() {
      //       for (
      //         let t = 0;
      //         t < this.upsellTags.length &&
      //         !(this.products.length >= this.limit);
      //         t++
      //       ) {
      //         var e = this.upsellTags[t];
      //         this.tagsInCart[e] &&
      //           this.taggedProducts[e] &&
      //           this.addToUpsellIfNotRedundant(this.taggedProducts[e]);
      //       }
      //     },
      //     fillUpsellWithDefaults() {
      //       for (
      //         let t = 0;
      //         t < this.defaultProducts.length &&
      //         !(this.products.length >= this.limit);
      //         t++
      //       ) {
      //         var e = this.defaultProducts[t];
      //         this.handlesInUpsell[e.handle] ||
      //           this.addToUpsellIfNotRedundant(e);
      //       }
      //     },
      //     async fetchUpsellHandles(t) {
      //       if (!t && !t.length) return Promise.resolve([]);
      //       let e = [];
      //       this.fetching = !0;
      //       console.log(t);
      //       try {
      //         for (let index = 0; index < t.length; index++) {
      //           console.log(t[index]);
      //           fetch(`/products/${t[index]}.js`).then((t) => {
      //             console.log(JSON.parse(t));
      //             e.push(JSON.parse(t));
      //           });
      //         }
      //       } catch (t) {
      //         console.error(t);
      //       } finally {
      //         return (this.fetching = !1), e;
      //       }
      //     },
      //     getUpsellHandles() {
      //       if (this.cart && this.cart.items) {
      //         let e,
      //           s = 0;
      //         const r = [];
      //         for (
      //           let t = 0;
      //           t < this.cart.items.length && !(s > this.limit);
      //           t++
      //         )
      //           (e = this.cart.items[t]?.properties?.upsell?.handle) &&
      //             !this.handlesInCart[e] &&
      //             (r.push(e), s++);
      //         return [...new Set(r)];
      //       }
      //     },
      //     removeUpsellProductsInCart() {
      //       let t = this.products.length;
      //       for (var e; t--; )
      //         (e = this.products[t].handle),
      //           this.handlesInCart[e] && this.products.splice(t, 1);
      //     },
      //     addToUpsellIfNotRedundant(t) {
      //       t &&
      //         t.handle &&
      //         (this.handlesInUpsell[t.handle] ||
      //           this.handlesInCart[t.handle] ||
      //           (this.products.push(t), (this.handlesInUpsell[t.handle] = !0)));
      //     },
      //     getHandles(t) {
      //       return Array.isArray(t)
      //         ? this.arrayIntoBooleanObject(t, "handle")
      //         : {};
      //     },
      //     changeSlide(t) {
      //       this.currentSlide = t;
      //     },
      //   },
      // };
      //var pcard = new ProductCard();
    },
    UpsellProduct() {
      return {
        delimiters: ["${", "}"],
        mixins: [this.mixins()],
        props: ["product"],
        data() {
          return {
            selectedVariant: this.getFirstAvailableVariant(),
            options: { 1: null, 2: null, 3: null },
          };
        },
        mounted() {
          (this.options[1] = this.selectedVariant.option1),
            (this.options[2] = this.selectedVariant.option2),
            (this.options[3] = this.selectedVariant.option3);
        },
        methods: {
          addToCart() {
            this.selectedVariant &&
              theme.CartAPI.add({
                id: this.selectedVariant.id,
                quantity: 1,
                upsell: { tags: this.product.tags, handle: null },
              });
          },
          getFirstAvailableVariant() {
            if (!this.product) return null;
            let e;
            for (let t = 0; t < this.product.variants.length; t++) {
              var s = this.product.variants[t];
              if (s.available) {
                e = s;
                break;
              }
            }
            return e;
          },
          onOptionChange() {
            this.selectedVariant = this.getVariantFromOptions(this.options);
          },
          getVariantFromOptions(i) {
            let a = !1;
            return (
              this.product.variants.forEach((t) => {
                let e = !0;
                for (const r in i) {
                  var s = `option${r}`;
                  e = e && i[r] === t[s];
                }
                e && (a = t);
              }),
              a
            );
          },
        },
      };
    },
    SkeletonItem() {
      return {};
    },
  };
}
class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this._selectors = {
      image: "[js-image]",
      variants: "[js-variant]",
      tags: "[js-tag]",
      addToCart: "[js-add-to-cart]",
      price: "[js-price]",
      featuredVariant: "[js-featured-variant]",
      loadingSpinner: "loading-spinner",
      selectedVariant: "[js-selected-btn]",
    }),
      (this.image = this.querySelector(this._selectors.image)),
      (this.tags = this.querySelectorAll(this._selectors.tags)),
      (this.button = this.querySelector(this._selectors.addToCart)),
      (this.selectedVariant = this.querySelector(
        this._selectors.selectedVariant
      )),
      this._setupVariantListeners(),
      this._initAddToCart();
    document.addEventListener("initializeProductCard", () => {
      (this._selectors = {
        image: "[js-image]",
        variants: "[js-variant]",
        tags: "[js-tag]",
        addToCart: "[js-add-to-cart]",
        price: "[js-price]",
        featuredVariant: "[js-featured-variant]",
        loadingSpinner: "loading-spinner",
        selectedVariant: "[js-selected-btn]",
      }),
        (this.image = this.querySelector(this._selectors.image)),
        (this.tags = this.querySelectorAll(this._selectors.tags)),
        (this.button = this.querySelector(this._selectors.addToCart)),
        (this.selectedVariant = this.querySelector(
          this._selectors.selectedVariant
        )),
        this._setupVariantListeners(),
        this._initAddToCart();
      $(".drawer-upsell-wrapper .arrow-btn").click(function () {
        $(this).parent().find(".product-swatch__group").css("display", "block");
        $(this).hide();
      });
      $(".drawer-upsell-wrapper .product-swatch__label").click(function () {
        //console.log($(this).data("varid"));
        $(this)
          .parents(".product-card__info")
          .find("input")
          .removeClass("active");
        $(this).parent().find("input").addClass("active");
        $(this)
          .parents(".product-card__link")
          .find(".pimg")
          .attr("src", $(this).data("img"));
        $(this)
          .parents(".product-item-n")
          .find("[js-add-to-cart]")
          .attr("data-variant-id", $(this).data("varid"));
      });
      $(".product-upsell-wrapper .arrow-btn").click(function () {
        $(this).parent().find(".product-swatch__group").css("display", "block");
        $(this).hide();
      });
      $(".product-upsell-wrapper .product-swatch__label").click(function () {
        //console.log($(this).data("varid"));
        $(this)
          .parents(".product-card__info")
          .find("input")
          .removeClass("active");
        $(this).parent().find("input").addClass("active");
        $(this)
          .parents(".product-card__link")
          .find(".pimg")
          .attr("src", $(this).data("img"));
        $(this)
          .parents(".product-item-n")
          .find("[js-add-to-cart]")
          .attr("data-variant-id", $(this).data("varid"));
      });
    });
  }
  _setupVariantListeners() {
    (this.swatches = this.querySelectorAll(this._selectors.variants)),
      this.swatches.length <= 0 ||
        (this.swatches.forEach((t) => {
          t.addEventListener("click", this._handleVariantChange);
        }),
        this._handleTagChange(this.swatches[0]),
        null != this.selectedVariant &&
          "false" != this.selectedVariant.dataset.available &&
          this.selectedVariant.click());
  }
  _handleVariantChange = (t) => {
    t.stopImmediatePropagation();
    const e = t.currentTarget;
    var s = e.getAttribute("data-img-src"),
      t = e.getAttribute("data-img-master");
    this.image.setAttribute("src", s),
      this.image.setAttribute("srcset", t),
      this.swatches.forEach((t) => {
        t.removeAttribute("disabled");
      }),
      e.setAttribute("disabled", "disabled"),
      null != this.tags && this._handleTagChange(e),
      null != this.button &&
        (this._handleButtonChange(e),
        (t = e.getAttribute("data-title")),
        this._handleVariantTitleChange(t),
        (t = e.getAttribute("data-id")),
        this.button.setAttribute("data-variant-id", t));
  };
  _handleTagChange = (t) => {
    const e = t.getAttribute("data-tag");
    let s = null;
    this.tags.forEach((t) => {
      (t.style.display = "none"), t.getAttribute("data-tag") == e && (s = t);
    }),
      null != s && (s.style.display = "inline-block");
  };
  _handleButtonChange = (t) => {
    var e = "$" + t.getAttribute("data-price").slice(0, -2);
    "false" == t.getAttribute("data-available")
      ? (this.button.setAttribute("disabled", "disabled"),
        (this.button.innerHTML = "Sold Out"))
      : (this.button.disabled && this.button.removeAttribute("disabled"),
        (this.button.innerHTML = `<span class="article-featured-product__price mr-9">
                            ${e}</span>
                          <span>ADD</span>`));
  };
  _handleVariantTitleChange = (t) => {
    this.querySelector(this._selectors.featuredVariant).innerHTML = t;
  };
  _initAddToCart() {
    const t = this.querySelector(this._selectors.addToCart);
    t && t.addEventListener("click", this._addToCart);
  }
  _addToCart = async (e) => {
    // if($(this).parents('.drawer-upsell-wrapper').length > 0){
    //   e.preventDefault();
    //   e.stopPropagation();
    // }
    var t = this.button.getAttribute("data-selling_plan_id"),
      e = this.button.getAttribute("data-variant-id");
    let s = { id: e, quantity: 1 };
    if (e) {
      this._onLoad(), t && (s.selling_plan = t);
      try {
        await theme.CartAPI.add({ items: [s] });
      } catch (t) {
        //console.log(error);
      } finally {
        this._onFinishLoad();
      }
    }
  };
  _onLoad = (t) => {
    t && t.stopPropagation(),
      this.querySelectorAll(this._selectors.loadingSpinner).forEach((t) =>
        t.setAttribute("loading", "")
      );
  };
  _onFinishLoad = (t) => {
    t && t.stopPropagation(),
      this.querySelectorAll(this._selectors.loadingSpinner).forEach((t) =>
        t.removeAttribute("loading")
      );
  };
  _removeEventListeners() {
    (this.swatches = this.querySelectorAll(this._selectors.variants)),
      this.swatches.length <= 0 ||
        this.swatches.forEach((t) => {
          t.removeEventListener("click", this._handleVariantChange);
        });
  }
  disconnectedCallback() {
    this._removeEventListeners();
  }
}
customElements.define("s-drawer", Drawer),
  customElements.define("s-modal", Modal),
  customElements.define("s-accordion", Accordion),
  customElements.define("s-tabs", Tabs),
  customElements.define("s-ajaxcart", AjaxCart),
  customElements.define("s-carousel", Carousel),
  customElements.define("announcement-bar", AnnouncementBar),
  customElements.define("product-options", ProductOptions),
  customElements.define("product-options-upsell", ProductOptionsupsell),
  customElements.define("product-options-qv", ProductOptionsQv),
  customElements.define("quantity-input", QuantityInput),
  customElements.define("product-card", ProductCard),
  customElements.define("loading-spinner", LoadingSpinner),
  customElements.define("predictive-search", PredictiveSearch);
class MainCollection extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { productGrid: "[js-products-grid]" }),
      (this._events = { fetch: "section:fetched" }),
      (this._cache = []);
  }
  connectedCallback() {
    this._setListeners();
  }
  _setListeners() {
    this.addEventListener("filter:change", this._handleFilterChange);
  }
  _handleFilterChange(t) {
    var t = t.detail["searchParams"];
    const e = `${window.location.pathname}?section_id=${this.dataset.id}&${t}`;
    t = (t) => t.url === e;
    this._cache.some(t) ? this._renderFromCache(t) : this._renderFromFetch(e);
  }
  _renderFromCache(t) {
    var e = this._cache.find(t).html,
      t = new DOMParser().parseFromString(e, "text/html");
    this.querySelector("filter-sort").dispatchEvent(
      new CustomEvent(this._events.fetch, { detail: { html: e } })
    ),
      this._renderProducts(t);
  }
  _renderFromFetch(s) {
    let r = this._cache;
    fetch(s)
      .then((t) => t.text())
      .then((t) => {
        var e = t,
          t = new DOMParser().parseFromString(e, "text/html");
        (r = [...r, { html: e, url: s }]),
          this.querySelector("filter-sort").dispatchEvent(
            new CustomEvent(this._events.fetch, { detail: { html: e } })
          ),
          this._renderProducts(t);
      });
  }
  _renderProducts(t) {
    this.querySelector(this._selectors.productGrid).innerHTML = t.querySelector(
      this._selectors.productGrid
    ).innerHTML;
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this._selectors = {
        form: "[js-form]",
        filter: "[js-filter]",
        mobile: "[js-mobile]",
        desktop: "[js-desktop]",
        productsCounter: "[js-products-count]",
        activeFilters: "[js-active-filters]",
        activeFiltersCount: "[js-filter-count]",
        desktopFiltersContainer: "[js-desktop-filters-container]",
      }),
      (this._events = { change: "filter:change" }),
      (this._onSubmitHandlerEvent = null),
      (this._debouncedOnSubmit = theme.utils.debounce((t) => {
        this._onSubmitHandler(t);
      }, 500));
  }
  connectedCallback() {
    (this._forms = this.querySelectorAll(this._selectors.form)),
      this._setListeners();
  }
  _setListeners() {
    window.addEventListener("popstate", this._onHistoryChange),
      this._forms.forEach((t) =>
        t.addEventListener("input", this._debouncedOnSubmit)
      ),
      this.addEventListener("section:fetched", this._renderComponent);
  }
  _renderComponent = (t) => {
    var t = t.detail["html"];
    if (t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector("filter-sort");
      this._renderFilters(
        e.querySelector(this._selectors.mobile),
        this.querySelector(this._selectors.mobile)
      ),
        this._renderFilters(
          e.querySelector(this._selectors.desktop),
          this.querySelector(this._selectors.desktop)
        ),
        this._renderProductCounts(e),
        this._renderActiveFilters(e);
    }
  };
  _renderFilters(t, e) {
    const s = this._onSubmitHandlerEvent,
      r = [...t.querySelectorAll(this._selectors.filter)];
    r.forEach((t) => {
      e.querySelector(
        `${this._selectors.filter}[data-index="${t.dataset.index}"]`
      ).innerHTML = t.innerHTML;
    });
    t = r.find((t) => {
      var e = s ? s.target.closest(this._selectors.filter) : void 0;
      return !!e && t.dataset.index === e.dataset.index;
    });
    t && this._renderFilterCounts(t, s.target.closest(this._selectors.filter));
  }
  _renderProductCounts(t) {
    this._refreshElements(this._selectors.productsCounter, t);
  }
  _renderActiveFilters(t) {
    this._refreshElements(this._selectors.activeFilters, t);
  }
  _renderFilterCounts(t, e) {
    var s;
    t &&
      e &&
      ((s = e.querySelector(this._selectors.activeFiltersCount)),
      t.querySelector(this._selectors.activeFiltersCount) &&
        s &&
        (e.querySelector(this._selectors.activeFiltersCount).outerHTML =
          t.querySelector(this._selectors.activeFiltersCount).outerHTML));
  }
  _refreshElements(t, e) {
    const s = e.querySelectorAll(t),
      r = this.querySelectorAll(t);
    r.forEach((t, e) => {
      s[e] && (t.innerHTML = s[e].innerHTML);
    });
  }
  _onSubmitHandler = (t) => {
    t.preventDefault(), (this._onSubmitHandlerEvent = t);
    (t = new FormData(t.target.closest("form"))),
      (t = new URLSearchParams(t).toString());
    this._propagateChange(t);
  };
  _onHistoryChange = (t) => {
    t = t.state ? t.state.searchParams : FilterSort.searchParamsInitial;
    t !== FilterSort.searchParamsPrev &&
      (this._propagateChange(t, !1), (this._onSubmitHandlerEvent = null));
  };
  onActiveFilterClick = (t) => {
    t.preventDefault();
    t =
      -1 == t.currentTarget.href.indexOf("?")
        ? ""
        : t.currentTarget.href.slice(t.currentTarget.href.indexOf("?") + 1);
    this._propagateChange(t);
  };
  _propagateChange(t, e = !0) {
    this.dispatchEvent(
      new CustomEvent(this._events.change, {
        detail: { searchParams: t },
        bubbles: !0,
      })
    ),
      e && this._updateURLHash(t);
  }
  _updateURLHash(t) {
    history.pushState(
      { searchParams: t },
      "",
      `${window.location.pathname}${t && "?".concat(t)}`
    );
  }
}
(FilterSort.searchParamsInitial = window.location.search.slice(1)),
  (FilterSort.searchParamsPrev = window.location.search.slice(1));
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((t) =>
        t.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(t) {
    this.adjustToValidValues(t.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    var t = this.querySelectorAll("input");
    const e = t[0],
      s = t[1];
    s.value && e.setAttribute("max", s.value),
      e.value && s.setAttribute("min", e.value),
      "" === e.value && s.setAttribute("min", 0),
      "" === s.value && e.setAttribute("max", s.getAttribute("max"));
  }
  adjustToValidValues(t) {
    var e = Number(t.value),
      s = Number(t.getAttribute("min")),
      r = Number(t.getAttribute("max"));
    e < s && (t.value = s), r < e && (t.value = r);
  }
}
class FilterRemove extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("a").addEventListener("click", (t) => {
        t.preventDefault(),
          document.querySelector("filter-sort").onActiveFilterClick(t);
      });
  }
}
class MainProduct extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        price: "[js-price]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        carousel: "[js-carousel]",
        slide: "[js-carousel-slide]",
        activeSlide: "[js-carousel-slide-active]",
        dots: "[js-carousel-dots]",
        variantSelector: "[js-variant-selector]",
        preOrderItem: "[js-pre-order]",
      }),
      (this._options = {
        cellAlign: "left",
        imagesLoaded: !0,
        contain: !0,
        pageDots: !1,
        prevNextButtons: !1,
        cellSelector: this._selectors.activeSlide,
        wrapAround: 0,
      });
  }
  connectedCallback() {
    this.addEventListener("variant:change", this._handleVariantChange),
      this.dataset.variant && this._updateCarousel(this.dataset.variant),
      this._initProductForm();

    $(".faq-questions-" + this.getAttribute("data-section-id")).click(function (
      e
    ) {
      e.preventDefault();

      let $this = $(this);

      if ($this.next().hasClass("show")) {
        $this.next().removeClass("show");
        $this.next().slideUp(350);
        $this.parent().removeClass("active");

        $this
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-down")
          .css({ display: "flex" });
        $this
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-up")
          .css({ display: "none" });
      } else {
        $(".custom-card-main").find(".faq-answers").removeClass("show");
        $(".custom-card-main").find(".faq-answers").slideUp(350);
        $(".custom-card-main").removeClass("active");

        $(".custom-card-main")
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-down")
          .css({ display: "flex" });
        $(".custom-card-main")
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-up")
          .css({ display: "none" });

        $this.next().toggleClass("show");
        $this.next().slideToggle(350);
        $this.parent().toggleClass("active");

        $this
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-down")
          .css({ display: "none" });
        $this
          .find(".fa-chevron-arrows")
          .find(".fa-chevron-up")
          .css({ display: "flex" });
      }
      // if ($this.parent().hasClass('active')) {
      //     $this.parent().removeClass('active');
      // } else {
      //     $('.custom-card-main').find('.custom-card-main').removeClass('active');
      //     $this.parent().toggleClass('active');
      // }
    });
  }
  _initProductForm() {
    const e = this.querySelector(this._selectors.form),
      s = this.querySelectorAll(this._selectors.addToCart);
    e &&
      e.addEventListener("submit", async (t) => {
        t.preventDefault(),
          s.forEach((t) => {
            t.setAttribute("disabled", ""),
              t
                .querySelector(this._selectors.loader)
                ?.setAttribute("loading", "");
          });
        try {
          await theme.CartAPI.addFromForm(e);
        } catch (t) {
          //console.log(error);
        } finally {
          s.forEach((t) => {
            t.removeAttribute("disabled"),
              t
                .querySelector(this._selectors.loader)
                ?.removeAttribute("loading");
          });
        }
      });
  }
  _handleVariantChange = (t) => {
    const { variant: e, changedPrice: s } = t.detail;
    t = e.option1
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    this._updateAddToCartState(e),
      e && (s && this._updatePrice(e), this._updateCarousel(t));
  };
  _getPreOrderStatus(e) {
    var s = this.querySelector(this._selectors.variantSelector);
    for (let t = 0; t < s.length; t++) {
      const a = s.options[t];
      var r = a.value,
        i = a.getAttribute("data-preorder");
      if (e == r) return "true" == i;
    }
    return !1;
  }
  _updatePreOrderProperty(t) {
    const e = this.querySelector(this._selectors.preOrderItem);
    e && (e.value = t);
  }
  _updateAddToCartState(t) {
    const e = this.querySelectorAll(this._selectors.addToCart);
    var s;
    t
      ? ((s = this._getPreOrderStatus(t.id)),
        this._updatePreOrderProperty(s),
        t.available
          ? s
            ? e.forEach((t) => {
                // (t.textContent = "Pre-Order"), t.removeAttribute("disabled");
                $(".buy_button-neen").find(".add-to-cart").text("Pre-Order");
                $(".buy_button-neen")
                  .find(".add-to-cart")
                  .removeAttr("disabled");
              })
            : e.forEach((t) => {
                var addtext =
                  $(".product-swatch__input:checked")
                    .parent()
                    .find("label")
                    .data("price") + " Add To Cart";

                //(t.textContent = addtext), t.removeAttribute("disabled");
                $(".buy_button-neen").find(".add-to-cart").text(addtext);
                $(".buy_button-neen")
                  .find(".add-to-cart")
                  .removeAttr("disabled");
              })
          : e.forEach((t) => {
              // (t.textContent = "Sold out"), t.setAttribute("disabled", "");
              $(".buy_button-neen").find(".add-to-cart").text("Sold out");
              $(".buy_button-neen").find(".add-to-cart").attr("disabled", true);
            }))
      : e.forEach((t) => {
          // (t.textContent = "Unavailable"), t.setAttribute("disabled", "");
          $(".buy_button-neen").find(".add-to-cart").text("Unavailable");
          $(".buy_button-neen").find(".add-to-cart").attr("disabled", true);
        });
  }
  _updatePrice(e) {
    const t = this.querySelectorAll(this._selectors.price);
    t.forEach((t) =>
      t.textContent(theme.utils.formatMoney(e.price, theme.config.money.format))
    );
  }
  _updateCarousel(e) {
    const t = this.querySelector(this._selectors.carousel),
      s = this.querySelectorAll(this._selectors.slide),
      r = this.querySelector(this._selectors.dots),
      i = r.querySelectorAll("button");
    t.classList.contains("flickity-enabled") && Flickity.data(t).destroy();
    var a = 0;
    i.forEach((t) => {
      t.dataset.color == e
        ? (t.classList.remove("hidden"),
          (t.dataset.index = a),
          (t.ariaLabel = "Go to slide " + a + 1),
          0 == a && t.classList.add("selected"),
          a++)
        : (t.classList.remove("selected"),
          t.classList.add("hidden"),
          (t.dataset.index = "null"));
    }),
      s.forEach((t) => {
        t.dataset.color == e
          ? (t.setAttribute("js-carousel-slide-active", ""),
            t.classList.remove("hidden"))
          : (t.removeAttribute("js-carousel-slide-active"),
            t.classList.add("hidden"));
      });
    var n = new Flickity(t, this._options);
    this._initCarouselControls(n);
  }
  _initCarouselControls(s) {
    const e = this.querySelector(this._selectors.dots),
      r = e.querySelectorAll("button");
    s.on("change", function (t) {
      r.forEach((t) => {
        t.classList.remove("selected");
      }),
        e.querySelector('[data-index="' + t + '"]').classList.add("selected");
    }),
      r.forEach((t) => {
        t.addEventListener("click", function (t) {
          var e = t.currentTarget,
            t = e.dataset.index;
          s.select(t, !0, !1),
            r.forEach((t) => {
              t.classList.remove("selected");
            }),
            e.classList.add("selected");
        });
      });
  }
}
class MainProductQv extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addToCart: "[js-add-to-cart]",
        price: "[js-price]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        carousel: "[js-carousel]",
        slide: "[js-carousel-slide]",
        activeSlide: "[js-carousel-slide-active]",
        dots: "[js-carousel-dots]",
        variantSelector: "[js-variant-selector]",
        preOrderItem: "[js-pre-order]",
      }),
      (this._options = {
        imagesLoaded: !0,
        contain: !0,
        pageDots: !1,
        prevNextButtons: !1,
        cellSelector: this._selectors.activeSlide,
        wrapAround: !0,
      });
  }
  connectedCallback() {
    this.addEventListener("variant:change", this._handleVariantChange),
      this.dataset.variant && this._updateCarousel(this.dataset.variant),
      this._initProductForm();
  }
  _initProductForm() {
    const e = this.querySelector(this._selectors.form),
      s = this.querySelectorAll(this._selectors.addToCart);
    e &&
      e.addEventListener("submit", async (t) => {
        t.preventDefault(),
          s.forEach((t) => {
            t.setAttribute("disabled", ""),
              t
                .querySelector(this._selectors.loader)
                ?.setAttribute("loading", "");
          });
        try {
          await theme.CartAPI.addFromForm(e);
        } catch (t) {
          //console.log(error);
        } finally {
          s.forEach((t) => {
            t.removeAttribute("disabled"),
              t
                .querySelector(this._selectors.loader)
                ?.removeAttribute("loading");
          });
        }
      });
  }
  _handleVariantChange = (t) => {
    const { variant: e, changedPrice: s } = t.detail;
    t = e.option1
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    this._updateAddToCartState(e),
      e && (s && this._updatePrice(e), this._updateCarousel(t));
  };
  _getPreOrderStatus(e) {
    var s = this.querySelector(this._selectors.variantSelector);
    for (let t = 0; t < s.length; t++) {
      const a = s.options[t];
      var r = a.value,
        i = a.getAttribute("data-preorder");
      if (e == r) return "true" == i;
    }
    return !1;
  }
  _updatePreOrderProperty(t) {
    const e = this.querySelector(this._selectors.preOrderItem);
    e && (e.value = t);
  }
  _updateAddToCartState(t) {
    const e = this.querySelectorAll(this._selectors.addToCart);
    var s;
    t
      ? ((s = this._getPreOrderStatus(t.id)),
        this._updatePreOrderProperty(s),
        t.available
          ? s
            ? e.forEach((t) => {
                (t.textContent = "Pre-Order"), t.removeAttribute("disabled");
              })
            : e.forEach((t) => {
                (t.textContent = "Add To Cart"), t.removeAttribute("disabled");
              })
          : e.forEach((t) => {
              (t.textContent = "Sold out"), t.setAttribute("disabled", "");
            }))
      : e.forEach((t) => {
          (t.textContent = "Unavailable"), t.setAttribute("disabled", "");
        });
  }
  _updatePrice(e) {
    const t = this.querySelectorAll(this._selectors.price);
    t.forEach((t) =>
      t.textContent(theme.utils.formatMoney(e.price, theme.config.money.format))
    );
  }
  _updateCarousel(e) {
    const t = this.querySelector(this._selectors.carousel),
      s = this.querySelectorAll(this._selectors.slide),
      r = this.querySelector(this._selectors.dots),
      i = r.querySelectorAll("button");
    t.classList.contains("flickity-enabled") && Flickity.data(t).destroy();
    var a = 0;
    i.forEach((t) => {
      t.dataset.color == e
        ? (t.classList.remove("hidden"),
          (t.dataset.index = a),
          (t.ariaLabel = "Go to slide " + a + 1),
          0 == a && t.classList.add("selected"),
          a++)
        : (t.classList.remove("selected"),
          t.classList.add("hidden"),
          (t.dataset.index = "null"));
    }),
      s.forEach((t) => {
        t.dataset.color == e
          ? (t.setAttribute("js-carousel-slide-active", ""),
            t.classList.remove("hidden"))
          : (t.removeAttribute("js-carousel-slide-active"),
            t.classList.add("hidden"));
      });
    var n = new Flickity(t, this._options);
    this._initCarouselControls(n);
  }
  _initCarouselControls(s) {
    const e = this.querySelector(this._selectors.dots),
      r = e.querySelectorAll("button");
    s.on("change", function (t) {
      r.forEach((t) => {
        t.classList.remove("selected");
      }),
        e.querySelector('[data-index="' + t + '"]').classList.add("selected");
    }),
      r.forEach((t) => {
        t.addEventListener("click", function (t) {
          var e = t.currentTarget,
            t = e.dataset.index;
          s.select(t, !0, !1),
            r.forEach((t) => {
              t.classList.remove("selected");
            }),
            e.classList.add("selected");
        });
      });
  }
}
class Video extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { videoModal: "[js-video]", iframe: "iframe" }),
      (this.elements = this._getElements()),
      this._setupEventListeners();
  }
  _getElements() {
    return { videoModals: this.querySelectorAll(this._selectors.videoModal) };
  }
  _setupEventListeners() {
    this.elements.videoModals.forEach((t) => {
      t.addEventListener("close", this._stopVideo);
    });
  }
  _stopVideo = (t) => {
    const e = t.currentTarget.querySelector(this._selectors.iframe);
    t = e.src;
    e.src = t;
  };
}
customElements.define("main-collection", MainCollection),
  customElements.define("filter-sort", FilterSort),
  customElements.define("price-range", PriceRange),
  customElements.define("filter-remove", FilterRemove),
  customElements.define("main-product", MainProduct),
  customElements.define("main-product-qv", MainProductQv);
class CustomerAddresses extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        customerAddresses: "[js-customer-addresses]",
        addressCountrySelect: "[js-country-select]",
        addAddressButton: "[js-add-address]",
        editAddressModal: "[js-edit-address-modal]",
        editAddressButton: "[js-edit-address]",
        editAddressForm: "[js-address-edit-form]",
        addressContainer: "[data-address]",
        cancelAddressButton: 'button[type="reset"]',
        deleteAddressButton: "[js-delete-address]",
      }),
      (this.elements = this._getElements()),
      this._setupCountries(),
      this._setupEventListeners();
  }
  _getElements() {
    return {
      deleteButtons: this.querySelectorAll(this._selectors.deleteAddressButton),
      countrySelects: this.querySelectorAll(
        this._selectors.addressCountrySelect
      ),
      editAddressButtons: this.querySelectorAll(
        this._selectors.editAddressButton
      ),
      addAddressButton: this.querySelectorAll(this._selectors.addAddressButton),
      editAddressModal: this.querySelector(this._selectors.editAddressModal),
      editAddressForms: this.querySelectorAll(this._selectors.editAddressForm),
    };
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        { hideElement: "AddressProvinceContainerNew" }
      ),
      this.elements.countrySelects.forEach((t) => {
        t = t.dataset.formId;
        new Shopify.CountryProvinceSelector(
          `AddressCountry_${t}`,
          `AddressProvince_${t}`,
          { hideElement: `AddressProvinceContainer_${t}` }
        );
      }));
  }
  _setupEventListeners() {
    this.elements.editAddressButtons.forEach((t) => {
      t.addEventListener("click", this._handleAddEditButtonClick);
    }),
      this.elements.deleteButtons.forEach((t) => {
        t.addEventListener("click", this._handleDeleteButtonClick);
      }),
      this.elements.addAddressButton.forEach((t) => {
        t.addEventListener("click", this._handleAddButtonClick);
      });
  }
  _handleAddButtonClick = (t) => {
    t.stopPropagation(),
      document.querySelector("#addAddressModal").open(),
      document.querySelector('[name="address[first_name]"]').focus();
  };
  _handleAddEditButtonClick = (t) => {
    t.stopPropagation();
    t = t.currentTarget.dataset.form;
    const e = document.querySelector("#address_form_" + t);
    e.classList.remove("hidden"),
      document.querySelector("#editAddressModal").open(),
      e.querySelector('[name="address[first_name]"]').focus();
    $("#editAddressModal form").hide();
    $("#address_form_" + t).show();
  };
  _handleDeleteButtonClick = ({ currentTarget: t }) => {
    confirm("Are you sure you want to delete this address?") &&
      Shopify.postLink(t.dataset.target, { parameters: { _method: "delete" } });
  };
  _handleModalClose = () => {
    this.elements.editAddressForms.forEach((t) => {
      t.classList.add("hidden");
    });
  };
}
customElements.define("customer-addresses", CustomerAddresses),
  customElements.define("s-video", Video);

$(".scrolltopbutton_arrow").on("click", function () {
  $("html").animate({ scrollTop: 0 }, "slow");
});

$(".customloginlink").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#customnewsletterlink").offset().top - 200,
    },
    500
  );
  $(".customnewsletterlinkinput").focus();
});

class CustomRelatedBlogs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".article-recommendations__articles", {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
        navigation: {
          nextEl: ".custom--button-next",
          prevEl: ".custom--button-prev",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-related-blogs", CustomRelatedBlogs);

class DynamicBlogPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var words = $(".dynamic-article-description>*").text();
      var first = words.charAt(0);
      $(".first-letter").append(first);
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("dynamic-blog-page", DynamicBlogPage);

class BundleProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $("bundle-product .selected-variants").click(function () {
        if ($(this).hasClass("active")) {
          $("bundle-product .selected-variants").removeClass("active");
        } else {
          $("bundle-product .selected-variants").removeClass("active");
          $(this).addClass("active");
        }
      });

      $(".bundle-products-description")
        .find(".bundle-products-main-wrapper")
        .removeClass("active");
      $("bundle-product .proucts-title").eq(0).addClass("active");
      $(".bundle-products-description")
        .find(".bundle-products-main-wrapper")
        .eq(0)
        .addClass("active");

      $("bundle-product .proucts-title").click(function () {
        var title = $(this).attr("match");
        $("bundle-product .proucts-title").removeClass("active");
        $(this).addClass("active");
        $(".bundle-products-description")
          .find(".bundle-products-main-wrapper")
          .removeClass("active");
        $(".bundle-products-description")
          .find('.bundle-products-main-wrapper[match="' + title + '"]')
          .addClass("active");
      });

      $("bundle-product .custom_bundle_content a").click(function () {
        var title = $(this).parents(".custom-bundle-info").attr("produt-title");
        $("bundle-product .proucts-title").removeClass("active");
        $("html, body").animate(
          {
            scrollTop: $("#data").offset().top - 240,
          },
          1000
        );
        $("bundle-product .main-products-title")
          .find('.proucts-title[match="' + title + '"]')
          .addClass("active");
        $(".bundle-products-description")
          .find(".bundle-products-main-wrapper")
          .removeClass("active");
        $(".bundle-products-description")
          .find('.bundle-products-main-wrapper[match="' + title + '"]')
          .addClass("active");
      });

      $("bundle-product .bundle-products-title").click(function () {
        $("bundle-product .bundle-products-title").removeClass("active");
        $(this).addClass("active");
      });

      $("bundle-product .custom-bundle-products-variants label")
        .unbind()
        .click(function () {
          var variant_image = $(this).attr("data-bg-image");
          var variable_title = $(this).siblings(".product-swatch__input").val();
          var variable_id = $(this).attr("data-id");

          $(this).parents(".custom-bundle-info").find(".err-msg").remove();

          $(this)
            .parents(".custom_bundle_variants")
            .find(".selected-variants")
            .removeClass("active");
          $(this)
            .parents(".custom_bundle_variants")
            .find(".selected-variants-swatch")
            .addClass("active");
          $(this)
            .parents(".custom_bundle_variants")
            .find(".selected-variants-swatch")
            .css("background-image", "url(" + variant_image + ")");
          $(this)
            .parents(".custom_bundle_variants")
            .find(".selected-variants-label")
            .text(variable_title);
          $(this)
            .parents(".custom-bundle-products")
            .attr("data-selected-variant", variable_id);
          $(this)
            .parents(".custom-bundle-products")
            .attr("variant-image", variant_image);
          $(this)
            .parents(".custom-bundle-products")
            .attr("variant-title", variable_title);
        });

      let mainProductID = $(
        "bundle-product .product-information__content_flitzip"
      ).attr("main-product");
      let mainProductHandle = $(
        "bundle-product .product-information__content_flitzip"
      ).attr("main-producthandle");
      let selectedVariants = [];

      $("bundle-product #add-selected-variants-to-cart").click(function (e) {
        $(".err-msg").remove();
        e.preventDefault();
        e.stopPropagation();
        selectedVariants = [];
        var allselected = true;
        $(".selected-variants-swatch").each(function () {
          if ($(this).hasClass("active") == false) {
            $(this)
              .parents(".custom_bundle_variants")
              .after(
                `<div class="err-msg" style="color:red;margin-top:10px;">Please select a shade</div>`
              );
            allselected = false;
          }
        });
        var unique = new Date().toString();
        var handle = "";
        var ids = "";
        var qtys = "";
        var inclueded = "";

        if (allselected == true) {
          var loader = $(this).find("loading-spinner");
          var textel = $(this).find("span");
          loader.attr("loading", "");
          textel.css("opacity", "0");

          $("bundle-product .custom-bundle-products").each(function () {
            var obj = {};
            ids = ids + "," + $(this).attr("data-selected-variant");
            handle = handle + "," + $(this).attr("data-selected-handle");
            qtys = qtys + ",1";
            if ($(this).find(".selected-variants-label").length > 0) {
              inclueded =
                inclueded +
                ",\r\n" +
                $(this).attr("data-selected-title") +
                " - " +
                $(this).find(".selected-variants-label").html();
            } else {
              inclueded =
                inclueded + ",\r\n" + $(this).attr("data-selected-title");
            }
          });

          //console.log("Selected variants are:", selectedVariants);
          var obj = {};
          obj["id"] = mainProductID;
          obj["quantity"] = 1;
          obj["properties[_bundle]"] = true;
          obj["properties[_uniqueid]"] = unique;
          obj["properties[_prbundleids]"] = ids.substring(1);
          obj["properties[_prhandles]"] = handle.substring(1);
          obj["properties[_prbundleqty]"] = qtys.substring(1);
          obj["properties[Included]"] = inclueded.substring(1);
          selectedVariants.push(obj);

          //console.log("All items to add to cart:", selectedVariants);

          //Call function to add items to cart
          addItemsToCart(selectedVariants);
        }
      });

      function addItemsToCart(items) {
        // Example AJAX call to add items to the cart
        $.ajax({
          type: "POST",
          url: "/cart/add.js", // Replace with your cart endpoint
          data: {
            items: items,
          },
          dataType: "json",
          success: function (response) {
            var loader = $(
              "bundle-product #add-selected-variants-to-cart"
            ).find("loading-spinner");
            var textel = $(
              "bundle-product #add-selected-variants-to-cart"
            ).find("span");
            loader.removeAttr("loading");
            //console.log("ADDTOCART===", data.items);
            textel.css("opacity", "1");
            var url = new URL(window.location.href);

            url.searchParams.append("viewcart", "true");
            window.location.href = url.href;
            // var event = new CustomEvent("cart:add:complete");
            // document.dispatchEvent(event);
          },
          error: function (xhr, status, error) {},
        });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("bundle-product", BundleProduct);

/* drawer upsell */
$(document).ready(function () {
  $(".drawer-upsell-wrapper .arrow-btn").click(function () {
    $(this).parent().find(".product-swatch__group").css("display", "block");
    $(this).hide();
  });
  $(".drawer-upsell-wrapper .product-swatch__label").click(function () {
    //console.log($(this).data("varid"));
    $(this).parents(".product-card__info").find("input").removeClass("active");
    $(this).parent().find("input").addClass("active");
    $(this)
    .parents(".product-card__link")
    .find(".pimg")
    .attr("src", $(this).data("img"));
    $(this)
    .parents(".product-item-n")
    .find("[js-add-to-cart]")
    .attr("data-variant-id", $(this).data("varid"));
  });
  $(".product-upsell-wrapper .arrow-btn").click(function () {
    $(this).parent().find(".product-swatch__group").css("display", "block");
    $(this).hide();
  });
  $(".product-upsell-wrapper .product-swatch__label").click(function () {
    console.log($(this).data("itemurl"));
    //console.log($(this).data("varid"));
    $(this).parents(".product-card__info").find("input").removeClass("active");
    $(this).parent().find("input").addClass("active");
    $(this)
      .parents(".product-card__link")
      .find(".pimg")
      .attr("src", $(this).data("img"));
    $(this)
      .parents(".product-item-n")
      .find("[js-add-to-cart]")
      .attr("data-variant-id", $(this).data("varid"));
    $(this)
      .parents(".product-item-n")
      .find("a")
      .attr("href", $(this).data("itemurl"));
  });
});
/* drawer upsell */

// custom js

class customannouncementbar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".customloginlink").click(function () {
        $("html, body").animate(
          {
            scrollTop: $("#customnewsletterlink").offset().top - 200,
          },
          500
        );
        $(".customnewsletterlinkinput").focus();
      });
      var swiper = new Swiper(
        ".announcementbar-new--" + this.getAttribute("data-sectionid"),
        {
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-announcement-bar", customannouncementbar);

class variantslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".variant-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 5,
          freeMode: true,
          navigation: {
            nextEl: ".swiper-button-next-var",
            prevEl: ".swiper-button-prev-var",
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("variant-slider", variantslider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".custom-card-main").find(".faq-answers").removeClass("show");
            $(".custom-card-main").find(".faq-answers").slideUp(350);
            $(".custom-card-main").removeClass("active");

            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
          // if ($this.parent().hasClass('active')) {
          //     $this.parent().removeClass('active');
          // } else {
          //     $('.custom-card-main').find('.custom-card-main').removeClass('active');
          //     $this.parent().toggleClass('active');
          // }
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);
